/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { Answer } from '../model/answer';
// @ts-ignore
import { BeneficialOwnerPEP } from '../model/beneficial-owner-pep';
// @ts-ignore
import { BeneficialOwnerPEPCopyResponse } from '../model/beneficial-owner-pep-copy-response';
// @ts-ignore
import { BeneficialOwnerPEPUpdate } from '../model/beneficial-owner-pep-update';
// @ts-ignore
import { BeneficialOwnerPEPUpdateRequest } from '../model/beneficial-owner-pep-update-request';
// @ts-ignore
import { CompanyJoinRequests } from '../model/company-join-requests';
// @ts-ignore
import { CompanyJoinRequestsRequest } from '../model/company-join-requests-request';
// @ts-ignore
import { CreateFile } from '../model/create-file';
// @ts-ignore
import { CreateFileRequest } from '../model/create-file-request';
// @ts-ignore
import { CreatePepCheck } from '../model/create-pep-check';
// @ts-ignore
import { CreatePepCheckRequest } from '../model/create-pep-check-request';
// @ts-ignore
import { DealflowFile } from '../model/dealflow-file';
// @ts-ignore
import { DeckAnalysis } from '../model/deck-analysis';
// @ts-ignore
import { DeckAnalysisRequest } from '../model/deck-analysis-request';
// @ts-ignore
import { DeckAnswerUpdateRequest } from '../model/deck-answer-update-request';
// @ts-ignore
import { DeckCompanyDetail } from '../model/deck-company-detail';
// @ts-ignore
import { DeckCompanyDetailRequest } from '../model/deck-company-detail-request';
// @ts-ignore
import { DeckContactUs } from '../model/deck-contact-us';
// @ts-ignore
import { DeckCreateInvestment } from '../model/deck-create-investment';
// @ts-ignore
import { DeckCreateInvestmentRequest } from '../model/deck-create-investment-request';
// @ts-ignore
import { DeckCreateUser } from '../model/deck-create-user';
// @ts-ignore
import { DeckCreateUserRequest } from '../model/deck-create-user-request';
// @ts-ignore
import { DeckDetailInvestment } from '../model/deck-detail-investment';
// @ts-ignore
import { DeckDetailInvestmentRequest } from '../model/deck-detail-investment-request';
// @ts-ignore
import { DeckInvestmentCompany } from '../model/deck-investment-company';
// @ts-ignore
import { DeckInvestmentCompanyCreate } from '../model/deck-investment-company-create';
// @ts-ignore
import { DeckInvestmentCompanyCreateRequest } from '../model/deck-investment-company-create-request';
// @ts-ignore
import { DeckInvestmentCompanyDetail } from '../model/deck-investment-company-detail';
// @ts-ignore
import { DeckInvestmentCompanyRequest } from '../model/deck-investment-company-request';
// @ts-ignore
import { DeckListings } from '../model/deck-listings';
// @ts-ignore
import { DeckLogEntry } from '../model/deck-log-entry';
// @ts-ignore
import { DeckOffer } from '../model/deck-offer';
// @ts-ignore
import { DeckOfferRequest } from '../model/deck-offer-request';
// @ts-ignore
import { DeckPitchDetail } from '../model/deck-pitch-detail';
// @ts-ignore
import { DeckPitchDetailRequest } from '../model/deck-pitch-detail-request';
// @ts-ignore
import { DeckPitchSelfPublishDetail } from '../model/deck-pitch-self-publish-detail';
// @ts-ignore
import { DeckPitchSelfPublishDetailRequest } from '../model/deck-pitch-self-publish-detail-request';
// @ts-ignore
import { DeckPitchSelfPublishFileType } from '../model/deck-pitch-self-publish-file-type';
// @ts-ignore
import { DeckPitchSelfPublishFileTypeList } from '../model/deck-pitch-self-publish-file-type-list';
// @ts-ignore
import { DeckPitchSelfPublishFileTypeRequest } from '../model/deck-pitch-self-publish-file-type-request';
// @ts-ignore
import { DeckPitchesSubscription } from '../model/deck-pitches-subscription';
// @ts-ignore
import { DeckPitchesSubscriptionRequest } from '../model/deck-pitches-subscription-request';
// @ts-ignore
import { DeckQuestion } from '../model/deck-question';
// @ts-ignore
import { DeckQuestionRequest } from '../model/deck-question-request';
// @ts-ignore
import { DeckRejectionReason } from '../model/deck-rejection-reason';
// @ts-ignore
import { DeckSecondhandSubscription } from '../model/deck-secondhand-subscription';
// @ts-ignore
import { DeckSelfPublishTag } from '../model/deck-self-publish-tag';
// @ts-ignore
import { DeckSelfPublishTagRequest } from '../model/deck-self-publish-tag-request';
// @ts-ignore
import { DeckStatusChangeSelfPublishFile } from '../model/deck-status-change-self-publish-file';
// @ts-ignore
import { DeckStatusChangeSelfPublishFileRequest } from '../model/deck-status-change-self-publish-file-request';
// @ts-ignore
import { DeckUser } from '../model/deck-user';
// @ts-ignore
import { DeckUserDetail } from '../model/deck-user-detail';
// @ts-ignore
import { DeckUserPNR } from '../model/deck-user-pnr';
// @ts-ignore
import { DeckUserProfile } from '../model/deck-user-profile';
// @ts-ignore
import { DeckUserProfileRequest } from '../model/deck-user-profile-request';
// @ts-ignore
import { DeckUserRequest } from '../model/deck-user-request';
// @ts-ignore
import { FileLink } from '../model/file-link';
// @ts-ignore
import { FileRejectionReason } from '../model/file-rejection-reason';
// @ts-ignore
import { IndividualPEP } from '../model/individual-pep';
// @ts-ignore
import { IndividualPEPRequest } from '../model/individual-pep-request';
// @ts-ignore
import { InvestmentCompanyStatistics } from '../model/investment-company-statistics';
// @ts-ignore
import { InvestmentStatistics } from '../model/investment-statistics';
// @ts-ignore
import { InvestmentsExport } from '../model/investments-export';
// @ts-ignore
import { InvestmentsExportRequest } from '../model/investments-export-request';
// @ts-ignore
import { Link } from '../model/link';
// @ts-ignore
import { PaginatedBeneficialOwnerPEPList } from '../model/paginated-beneficial-owner-pep-list';
// @ts-ignore
import { PaginatedCompanyJoinRequestsList } from '../model/paginated-company-join-requests-list';
// @ts-ignore
import { PaginatedDeckAnalysisList } from '../model/paginated-deck-analysis-list';
// @ts-ignore
import { PaginatedDeckCompanyListList } from '../model/paginated-deck-company-list-list';
// @ts-ignore
import { PaginatedDeckContactUsList } from '../model/paginated-deck-contact-us-list';
// @ts-ignore
import { PaginatedDeckDetailInvestmentList } from '../model/paginated-deck-detail-investment-list';
// @ts-ignore
import { PaginatedDeckInvestmentCompanyList } from '../model/paginated-deck-investment-company-list';
// @ts-ignore
import { PaginatedDeckInvestmentsList } from '../model/paginated-deck-investments-list';
// @ts-ignore
import { PaginatedDeckKYCList } from '../model/paginated-deck-kyc-list';
// @ts-ignore
import { PaginatedDeckListingsList } from '../model/paginated-deck-listings-list';
// @ts-ignore
import { PaginatedDeckOfferList } from '../model/paginated-deck-offer-list';
// @ts-ignore
import { PaginatedDeckPitchList } from '../model/paginated-deck-pitch-list';
// @ts-ignore
import { PaginatedDeckPitchSelfPublishDetailList } from '../model/paginated-deck-pitch-self-publish-detail-list';
// @ts-ignore
import { PaginatedDeckPitchSelfPublishFileTypeListList } from '../model/paginated-deck-pitch-self-publish-file-type-list-list';
// @ts-ignore
import { PaginatedDeckPitchesSubscriptionList } from '../model/paginated-deck-pitches-subscription-list';
// @ts-ignore
import { PaginatedDeckQuestionList } from '../model/paginated-deck-question-list';
// @ts-ignore
import { PaginatedDeckSecondhandSubscriptionList } from '../model/paginated-deck-secondhand-subscription-list';
// @ts-ignore
import { PaginatedDeckSelfPublishTagList } from '../model/paginated-deck-self-publish-tag-list';
// @ts-ignore
import { PaginatedDeckSimpleUserList } from '../model/paginated-deck-simple-user-list';
// @ts-ignore
import { PaginatedDeckUserList } from '../model/paginated-deck-user-list';
// @ts-ignore
import { PaginatedIndividualPEPList } from '../model/paginated-individual-pep-list';
// @ts-ignore
import { PatchedBatchCustomerStatusRequest } from '../model/patched-batch-customer-status-request';
// @ts-ignore
import { PatchedBeneficialOwnerPEPUpdateRequest } from '../model/patched-beneficial-owner-pep-update-request';
// @ts-ignore
import { PatchedCompanyJoinRequestsRequest } from '../model/patched-company-join-requests-request';
// @ts-ignore
import { PatchedCreatePepCheckRequest } from '../model/patched-create-pep-check-request';
// @ts-ignore
import { PatchedDealflowFileRequest } from '../model/patched-dealflow-file-request';
// @ts-ignore
import { PatchedDeckAnalysisRequest } from '../model/patched-deck-analysis-request';
// @ts-ignore
import { PatchedDeckAnswerUpdateRequest } from '../model/patched-deck-answer-update-request';
// @ts-ignore
import { PatchedDeckCompanyDetailRequest } from '../model/patched-deck-company-detail-request';
// @ts-ignore
import { PatchedDeckDetailInvestmentRequest } from '../model/patched-deck-detail-investment-request';
// @ts-ignore
import { PatchedDeckInvestmentCompanyCreateRequest } from '../model/patched-deck-investment-company-create-request';
// @ts-ignore
import { PatchedDeckInvestmentCompanyRequest } from '../model/patched-deck-investment-company-request';
// @ts-ignore
import { PatchedDeckListingsRequest } from '../model/patched-deck-listings-request';
// @ts-ignore
import { PatchedDeckOfferRequest } from '../model/patched-deck-offer-request';
// @ts-ignore
import { PatchedDeckPitchDetailRequest } from '../model/patched-deck-pitch-detail-request';
// @ts-ignore
import { PatchedDeckPitchSelfPublishDetailRequest } from '../model/patched-deck-pitch-self-publish-detail-request';
// @ts-ignore
import { PatchedDeckPitchSelfPublishFileTypeRequest } from '../model/patched-deck-pitch-self-publish-file-type-request';
// @ts-ignore
import { PatchedDeckPitchesSubscriptionRequest } from '../model/patched-deck-pitches-subscription-request';
// @ts-ignore
import { PatchedDeckQuestionRequest } from '../model/patched-deck-question-request';
// @ts-ignore
import { PatchedDeckSelfPublishTagRequest } from '../model/patched-deck-self-publish-tag-request';
// @ts-ignore
import { PatchedDeckStatusChangeSelfPublishFileRequest } from '../model/patched-deck-status-change-self-publish-file-request';
// @ts-ignore
import { PatchedDeckUserProfileRequest } from '../model/patched-deck-user-profile-request';
// @ts-ignore
import { PatchedDeckUserRequest } from '../model/patched-deck-user-request';
// @ts-ignore
import { PatchedInvestmentsExportRequest } from '../model/patched-investments-export-request';
// @ts-ignore
import { PitchStatistics } from '../model/pitch-statistics';
// @ts-ignore
import { QuestionnaireResponse } from '../model/questionnaire-response';
// @ts-ignore
import { SelfPublishFileType } from '../model/self-publish-file-type';
// @ts-ignore
import { UserStatistics } from '../model/user-statistics';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface BankidBeneficialOwnerPepCopyCreateRequestParams {
  /** A unique integer value identifying this beneficial owner pep check. */
  id: string;
}

export interface BankidBeneficialOwnerPepCopyInstanceCreateRequestParams {
  /** A unique integer value identifying this beneficial owner pep check. */
  id: string;
}

export interface BankidBeneficialOwnerPepLatestListRequestParams {
  company_id?: string;
  investment_company_id?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-company'
    | '-created_date'
    | '-first_name'
    | '-investment_company'
    | '-last_name'
    | '-modified_date'
    | '-status'
    | 'company'
    | 'created_date'
    | 'first_name'
    | 'investment_company'
    | 'last_name'
    | 'modified_date'
    | 'status';
  status?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  status_unwanted?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
}

export interface BankidBeneficialOwnerPepListRequestParams {
  company_id?: string;
  investment_company_id?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-company'
    | '-created_date'
    | '-first_name'
    | '-investment_company'
    | '-last_name'
    | '-modified_date'
    | '-status'
    | 'company'
    | 'created_date'
    | 'first_name'
    | 'investment_company'
    | 'last_name'
    | 'modified_date'
    | 'status';
  status?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  status_unwanted?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
}

export interface BankidBeneficialOwnerPepPartialUpdateRequestParams {
  /** A unique integer value identifying this beneficial owner pep check. */
  id: string;
  PatchedBeneficialOwnerPEPUpdateRequest?: PatchedBeneficialOwnerPEPUpdateRequest;
}

export interface BankidBeneficialOwnerPepReportLinkRetrieveRequestParams {
  /** A unique integer value identifying this beneficial owner pep check. */
  id: string;
}

export interface BankidBeneficialOwnerPepUpdateRequestParams {
  /** A unique integer value identifying this beneficial owner pep check. */
  id: string;
  BeneficialOwnerPEPUpdateRequest: BeneficialOwnerPEPUpdateRequest;
}

export interface BankidPepCheckLatestListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-created_date'
    | '-modified_date'
    | '-status'
    | '-user_first_name'
    | '-user_last_name'
    | 'created_date'
    | 'modified_date'
    | 'status'
    | 'user_first_name'
    | 'user_last_name';
  status?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  status_unwanted?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  user_id?: string;
}

export interface BankidPepCheckListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-created_date'
    | '-modified_date'
    | '-status'
    | '-user_first_name'
    | '-user_last_name'
    | 'created_date'
    | 'modified_date'
    | 'status'
    | 'user_first_name'
    | 'user_last_name';
  status?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  status_unwanted?: Array<'PEP' | 'PEP_AND_SANCTION' | 'SANCTION'>;
  user_id?: string;
}

export interface BankidPepCheckManualCreateRequestParams {
  IndividualPEPRequest: IndividualPEPRequest;
}

export interface CompaniesAmlCheckCreateRequestParams {
  /** A unique integer value identifying this company. */
  id: string;
  DeckCompanyDetailRequest: DeckCompanyDetailRequest;
}

export interface CompaniesAmlCheckPartialUpdateRequestParams {
  /** A unique integer value identifying this company. */
  id: string;
  PatchedDeckCompanyDetailRequest?: PatchedDeckCompanyDetailRequest;
}

export interface CompaniesCreateRequestParams {
  DeckCompanyDetailRequest: DeckCompanyDetailRequest;
}

export interface CompaniesListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?: '-created_date' | '-name' | '-total_raised' | 'created_date' | 'name' | 'total_raised';
}

export interface CompaniesPartialUpdateRequestParams {
  /** A unique integer value identifying this company. */
  id: string;
  PatchedDeckCompanyDetailRequest?: PatchedDeckCompanyDetailRequest;
}

export interface CompaniesRetrieveRequestParams {
  /** A unique integer value identifying this company. */
  id: string;
}

export interface CompaniesUpdateRequestParams {
  /** A unique integer value identifying this company. */
  id: string;
  DeckCompanyDetailRequest: DeckCompanyDetailRequest;
}

export interface CompanyRequestsListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?: '-status' | 'status';
  /** A search term. */
  search?: string;
  status?: 'accepted' | 'denied' | 'pending';
}

export interface CompanyRequestsPartialUpdateRequestParams {
  /** A unique integer value identifying this company to member request. */
  id: string;
  PatchedCompanyJoinRequestsRequest?: PatchedCompanyJoinRequestsRequest;
}

export interface CompanyRequestsRetrieveRequestParams {
  /** A unique integer value identifying this company to member request. */
  id: string;
}

export interface CompanyRequestsUpdateRequestParams {
  /** A unique integer value identifying this company to member request. */
  id: string;
  CompanyJoinRequestsRequest: CompanyJoinRequestsRequest;
}

export interface ContactUsListRequestParams {
  /** search by email or user names */
  filter?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
}

export interface ContactUsRetrieveRequestParams {
  /** A unique integer value identifying this contact us. */
  id: string;
}

export interface DealflowFilesCreateRequestParams {
  CreateFileRequest: CreateFileRequest;
}

export interface DealflowFilesDestroyRequestParams {
  /** A unique integer value identifying this dealflow file. */
  id: string;
}

export interface DealflowFilesPartialUpdateRequestParams {
  /** A unique integer value identifying this dealflow file. */
  id: string;
  PatchedDealflowFileRequest?: PatchedDealflowFileRequest;
}

export interface DealflowFilesRetrieveRequestParams {
  /** A unique integer value identifying this dealflow file. */
  id: string;
}

export interface DealflowFilesUpdateRequestParams {
  /** A unique integer value identifying this dealflow file. */
  id: string;
  CreateFileRequest: CreateFileRequest;
}

export interface InvestmentBatchPaidPartialUpdateRequestParams {
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface InvestmentBatchPaidUpdateRequestParams {
  DeckDetailInvestmentRequest: DeckDetailInvestmentRequest;
}

export interface InvestmentBatchSharesPartialUpdateRequestParams {
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface InvestmentBatchSharesUpdateRequestParams {
  DeckDetailInvestmentRequest: DeckDetailInvestmentRequest;
}

export interface InvestmentBatchStatusPartialUpdateRequestParams {
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface InvestmentBatchStatusUpdateRequestParams {
  DeckDetailInvestmentRequest: DeckDetailInvestmentRequest;
}

export interface InvestmentCompaniesAmlCheckCreateRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  DeckInvestmentCompanyRequest: DeckInvestmentCompanyRequest;
}

export interface InvestmentCompaniesAmlCheckPartialUpdateRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  PatchedDeckInvestmentCompanyRequest?: PatchedDeckInvestmentCompanyRequest;
}

export interface InvestmentCompaniesBatchRedPartialUpdateRequestParams {
  body?: string;
}

export interface InvestmentCompaniesCreateRequestParams {
  DeckInvestmentCompanyCreateRequest: DeckInvestmentCompanyCreateRequest;
}

export interface InvestmentCompaniesDownloadAgreementRetrieveRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
}

export interface InvestmentCompaniesListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-created_date'
    | '-name'
    | '-red'
    | '-test_status'
    | '-total_investment'
    | 'created_date'
    | 'name'
    | 'red'
    | 'test_status'
    | 'total_investment';
  user_id?: string;
}

export interface InvestmentCompaniesPartialUpdateRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  PatchedDeckInvestmentCompanyCreateRequest?: PatchedDeckInvestmentCompanyCreateRequest;
}

export interface InvestmentCompaniesRetrieveRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
}

export interface InvestmentCompaniesSaveAgreementCreateRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  DeckInvestmentCompanyRequest: DeckInvestmentCompanyRequest;
}

export interface InvestmentCompaniesUpdateRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  DeckInvestmentCompanyCreateRequest: DeckInvestmentCompanyCreateRequest;
}

export interface InvestmentCompaniesUsersListRequestParams {
  /** A unique integer value identifying this investment company. */
  id: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
}

export interface InvestmentCreateRequestParams {
  DeckDetailInvestmentRequest: DeckDetailInvestmentRequest;
}

export interface InvestmentDownloadAgreementRetrieveRequestParams {
  /** A unique integer value identifying this investment. */
  id: string;
}

export interface InvestmentInvestOnBehalfCreateRequestParams {
  DeckCreateInvestmentRequest: DeckCreateInvestmentRequest;
}

export interface InvestmentListRequestParams {
  added_from?: string;
  added_to?: string;
  agreement_idfy_id?: boolean;
  amount_from?: number;
  amount_to?: number;
  customer_status?: string;
  email?: string;
  investment_company_id?: string | null;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-amount'
    | '-created_date'
    | '-last_name'
    | '-payment_option'
    | '-pitch_name'
    | '-status'
    | 'amount'
    | 'created_date'
    | 'last_name'
    | 'payment_option'
    | 'pitch_name'
    | 'status';
  payment_option?: 's' | 'u' | 'w' | null;
  pitch_id?: string;
  pitch_name?: string;
  /** A search term. */
  search?: string;
  status?: Array<'A' | 'D' | 'P' | 'R' | 'U'>;
  unwanted_status?: Array<'A' | 'D' | 'P' | 'R' | 'U'>;
  user_id?: string;
  username?: string;
}

export interface InvestmentPaidPartialUpdateRequestParams {
  /** A unique integer value identifying this investment. */
  id: string;
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface InvestmentPaidUpdateRequestParams {
  /** A unique integer value identifying this investment. */
  id: string;
  DeckDetailInvestmentRequest: DeckDetailInvestmentRequest;
}

export interface InvestmentRetrieveRequestParams {
  /** A unique integer value identifying this investment. */
  id: string;
}

export interface InvestmentSendPaymentSlipPartialUpdateRequestParams {
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface InvestmentSendToAcceptedPartialUpdateRequestParams {
  PatchedDeckDetailInvestmentRequest?: PatchedDeckDetailInvestmentRequest;
}

export interface ListingsHandledPartialUpdateRequestParams {
  /** A unique integer value identifying this listing. */
  id: string;
  PatchedDeckListingsRequest?: PatchedDeckListingsRequest;
}

export interface ListingsListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** first name, last name, email, company name */
  search?: string;
}

export interface ListingsRetrieveRequestParams {
  /** A unique integer value identifying this listing. */
  id: string;
}

export interface PepcheckManualCreateRequestParams {
  CreatePepCheckRequest: CreatePepCheckRequest;
}

export interface PepcheckManualPartialUpdateRequestParams {
  /** A unique integer value identifying this pep check. */
  id: string;
  PatchedCreatePepCheckRequest?: PatchedCreatePepCheckRequest;
}

export interface PepcheckManualUpdateRequestParams {
  /** A unique integer value identifying this pep check. */
  id: string;
  CreatePepCheckRequest: CreatePepCheckRequest;
}

export interface PitchAcceptInvestmentsPartialUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  company_id?: string;
  company_name?: string;
  /** Multiple values may be separated by commas. */
  labels?: Array<string>;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-company_name'
    | '-end_day'
    | '-investors_number'
    | '-max_goal'
    | '-min_goal'
    | '-name'
    | '-total_raised'
    | 'company_name'
    | 'end_day'
    | 'investors_number'
    | 'max_goal'
    | 'min_goal'
    | 'name'
    | 'total_raised';
  /** public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -  */
  visibility?: Array<'ar' | 'cu' | 'dr' | 'pr' | 'pu' | 'un'>;
}

export interface PitchAcceptInvestmentsUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  company_id?: string;
  company_name?: string;
  /** Multiple values may be separated by commas. */
  labels?: Array<string>;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-company_name'
    | '-end_day'
    | '-investors_number'
    | '-max_goal'
    | '-min_goal'
    | '-name'
    | '-total_raised'
    | 'company_name'
    | 'end_day'
    | 'investors_number'
    | 'max_goal'
    | 'min_goal'
    | 'name'
    | 'total_raised';
  /** public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -  */
  visibility?: Array<'ar' | 'cu' | 'dr' | 'pr' | 'pu' | 'un'>;
}

export interface PitchBatchInviteCreateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchBatchStatusPartialUpdateRequestParams {
  PatchedDeckPitchDetailRequest?: PatchedDeckPitchDetailRequest;
}

export interface PitchBatchStatusUpdateRequestParams {
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchDownloadInvestmentsRetrieveRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
}

export interface PitchExportInvestmentsCreateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  InvestmentsExportRequest: InvestmentsExportRequest;
}

export interface PitchExportInvestmentsPartialUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  PatchedInvestmentsExportRequest?: PatchedInvestmentsExportRequest;
}

export interface PitchExportInvestmentsUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  InvestmentsExportRequest: InvestmentsExportRequest;
}

export interface PitchFeaturedPartialUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  PatchedDeckPitchDetailRequest?: PatchedDeckPitchDetailRequest;
}

export interface PitchFeaturedUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchHistoryRetrieveRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
}

export interface PitchInvitationsRetrieveRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
}

export interface PitchInviteCreateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchListRequestParams {
  company_id?: string;
  company_name?: string;
  /** Multiple values may be separated by commas. */
  labels?: Array<string>;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-company_name'
    | '-end_day'
    | '-investors_number'
    | '-max_goal'
    | '-min_goal'
    | '-name'
    | '-total_raised'
    | 'company_name'
    | 'end_day'
    | 'investors_number'
    | 'max_goal'
    | 'min_goal'
    | 'name'
    | 'total_raised';
  /** public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -  */
  visibility?: Array<'ar' | 'cu' | 'dr' | 'pr' | 'pu' | 'un'>;
}

export interface PitchPartialUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  PatchedDeckPitchDetailRequest?: PatchedDeckPitchDetailRequest;
}

export interface PitchRetrieveRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
}

export interface PitchSendEmailsCreateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchUpdateRequestParams {
  /** A unique integer value identifying this pitch. */
  id: string;
  DeckPitchDetailRequest: DeckPitchDetailRequest;
}

export interface PitchesAnalysesBatchMutedPartialUpdateRequestParams {
  PatchedDeckAnalysisRequest?: PatchedDeckAnalysisRequest;
}

export interface PitchesAnalysesListRequestParams {
  /** Pitch name or text */
  filter?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?: '-first_name' | '-last_name' | '-pitch_name' | 'first_name' | 'last_name' | 'pitch_name';
  pitch_id?: string;
  user_id?: string;
}

export interface PitchesAnalysesMutePartialUpdateRequestParams {
  /** A unique integer value identifying this analysis. */
  id: string;
  PatchedDeckAnalysisRequest?: PatchedDeckAnalysisRequest;
}

export interface PitchesAnalysesMuteUpdateRequestParams {
  /** A unique integer value identifying this analysis. */
  id: string;
  DeckAnalysisRequest: DeckAnalysisRequest;
}

export interface PitchesAnalysesRetrieveRequestParams {
  /** A unique integer value identifying this analysis. */
  id: string;
}

export interface PitchesSelfPublishFileTypesCreateRequestParams {
  DeckPitchSelfPublishFileTypeRequest: DeckPitchSelfPublishFileTypeRequest;
}

export interface PitchesSelfPublishFileTypesDestroyRequestParams {
  /** A unique integer value identifying this self publish file type. */
  id: string;
}

export interface PitchesSelfPublishFileTypesListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
}

export interface PitchesSelfPublishFileTypesPartialUpdateRequestParams {
  /** A unique integer value identifying this self publish file type. */
  id: string;
  PatchedDeckPitchSelfPublishFileTypeRequest?: PatchedDeckPitchSelfPublishFileTypeRequest;
}

export interface PitchesSelfPublishFileTypesRetrieveRequestParams {
  /** A unique integer value identifying this self publish file type. */
  id: string;
}

export interface PitchesSelfPublishFileTypesUpdateRequestParams {
  /** A unique integer value identifying this self publish file type. */
  id: string;
  DeckPitchSelfPublishFileTypeRequest: DeckPitchSelfPublishFileTypeRequest;
}

export interface PitchesSelfPublishFilesPartialUpdateRequestParams {
  /** A unique integer value identifying this self publish file. */
  id: string;
  PatchedDeckStatusChangeSelfPublishFileRequest?: PatchedDeckStatusChangeSelfPublishFileRequest;
}

export interface PitchesSelfPublishFilesRetrieveRequestParams {
  /** A unique integer value identifying this self publish file. */
  id: string;
}

export interface PitchesSelfPublishFilesUpdateRequestParams {
  /** A unique integer value identifying this self publish file. */
  id: string;
  DeckStatusChangeSelfPublishFileRequest?: DeckStatusChangeSelfPublishFileRequest;
}

export interface PitchesSelfPublishListRequestParams {
  created_from?: string;
  created_to?: string;
  /** pitch name and/or company name */
  filter?: string;
  /** Number of results to return per page. */
  limit?: number;
  modified_from?: string;
  modified_to?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?: '-company_name' | '-created_date' | '-pitch_name' | '-status' | 'company_name' | 'created_date' | 'pitch_name' | 'status';
  status?: Array<'accepted' | 'declaration' | 'details' | 'rejected' | 'sign_declaration' | 'sign_declaration_progress'>;
}

export interface PitchesSelfPublishPartialUpdateRequestParams {
  /** A unique integer value identifying this pitch self publish. */
  id: string;
  PatchedDeckPitchSelfPublishDetailRequest?: PatchedDeckPitchSelfPublishDetailRequest;
}

export interface PitchesSelfPublishRetrieveRequestParams {
  /** A unique integer value identifying this pitch self publish. */
  id: string;
}

export interface PitchesSelfPublishTagsCreateRequestParams {
  DeckSelfPublishTagRequest: DeckSelfPublishTagRequest;
}

export interface PitchesSelfPublishTagsDestroyRequestParams {
  /** A unique integer value identifying this self publish tag. */
  id: string;
}

export interface PitchesSelfPublishTagsListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
}

export interface PitchesSelfPublishTagsPartialUpdateRequestParams {
  /** A unique integer value identifying this self publish tag. */
  id: string;
  PatchedDeckSelfPublishTagRequest?: PatchedDeckSelfPublishTagRequest;
}

export interface PitchesSelfPublishTagsRetrieveRequestParams {
  /** A unique integer value identifying this self publish tag. */
  id: string;
}

export interface PitchesSelfPublishTagsUpdateRequestParams {
  /** A unique integer value identifying this self publish tag. */
  id: string;
  DeckSelfPublishTagRequest: DeckSelfPublishTagRequest;
}

export interface PitchesSelfPublishUpdateRequestParams {
  /** A unique integer value identifying this pitch self publish. */
  id: string;
  DeckPitchSelfPublishDetailRequest: DeckPitchSelfPublishDetailRequest;
}

export interface PitchesSubscriptionsListRequestParams {
  added_from?: string;
  added_to?: string;
  company_id?: string;
  /** email or name */
  filter?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-created_date'
    | '-email'
    | '-first_name'
    | '-last_name'
    | '-pitch_name'
    | 'created_date'
    | 'email'
    | 'first_name'
    | 'last_name'
    | 'pitch_name';
  pitch?: string;
  pitch_name?: string;
  subscribed?: boolean;
  user_id?: string | null;
}

export interface PitchesSubscriptionsRetrieveRequestParams {
  /** A unique integer value identifying this subscription. */
  id: string;
}

export interface PitchesSubscriptionsUnsubscribePartialUpdateRequestParams {
  /** A unique integer value identifying this subscription. */
  id: string;
  PatchedDeckPitchesSubscriptionRequest?: PatchedDeckPitchesSubscriptionRequest;
}

export interface PitchesSubscriptionsUnsubscribeUpdateRequestParams {
  /** A unique integer value identifying this subscription. */
  id: string;
  DeckPitchesSubscriptionRequest: DeckPitchesSubscriptionRequest;
}

export interface QuestionAnswerCreateRequestParams {
  /** A unique integer value identifying this question. */
  id: string;
  DeckAnswerUpdateRequest: DeckAnswerUpdateRequest;
}

export interface QuestionAnswerPartialUpdateRequestParams {
  /** A unique integer value identifying this question. */
  id: string;
  PatchedDeckAnswerUpdateRequest?: PatchedDeckAnswerUpdateRequest;
}

export interface QuestionBatchMutedPartialUpdateRequestParams {
  PatchedDeckQuestionRequest?: PatchedDeckQuestionRequest;
}

export interface QuestionListRequestParams {
  /** Pitch name or text */
  filter?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?: '-first_name' | '-last_name' | '-pitch_name' | 'first_name' | 'last_name' | 'pitch_name';
  pitch_id?: string;
  user_id?: string;
  username?: string;
}

export interface QuestionMutePartialUpdateRequestParams {
  /** A unique integer value identifying this question. */
  id: string;
  PatchedDeckQuestionRequest?: PatchedDeckQuestionRequest;
}

export interface QuestionMuteUpdateRequestParams {
  /** A unique integer value identifying this question. */
  id: string;
  DeckQuestionRequest: DeckQuestionRequest;
}

export interface QuestionRetrieveRequestParams {
  /** A unique integer value identifying this question. */
  id: string;
}

export interface QuestionnaireAnswersRetrieveRequestParams {
  object_id: string;
  slug: string;
}

export interface QuestionnaireListRequestParams {
  id?: string;
  /** Number of results to return per page. */
  limit?: number;
  model?: 'investment_company' | 'user';
  /** The initial index from which to return the results. */
  offset?: number;
}

export interface QuestionnaireRetrieveRequestParams {
  /** A unique integer value identifying this questionnaire. */
  id: string;
}

export interface SecondhandOffersCreateRequestParams {
  DeckOfferRequest: DeckOfferRequest;
}

export interface SecondhandOffersListRequestParams {
  /** Created after [YYYY-MM-DD] */
  created_date_from?: string;
  /** Created before [YYYY-MM-DD] */
  created_date_to?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** Updated after [YYYY-MM-DD] */
  modified_date_from?: string;
  /** Updated before [YYYY-MM-DD] */
  modified_date_to?: string;
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-created_date'
    | '-modified_date'
    | '-name'
    | '-shares'
    | '-status'
    | '-subscribed'
    | 'created_date'
    | 'modified_date'
    | 'name'
    | 'shares'
    | 'status'
    | 'subscribed';
  /** Shares greater or equal */
  shares_from?: number;
  /** Shares less or equal */
  shares_to?: number;
  status?: Array<'DRAFT' | 'PUBLIC' | 'SOLD' | 'WITHDRAWN'>;
  /** At least one subscribed [true, false] */
  subscribed?: boolean;
}

export interface SecondhandOffersPartialUpdateRequestParams {
  /** A unique integer value identifying this offer. */
  id: string;
  PatchedDeckOfferRequest?: PatchedDeckOfferRequest;
}

export interface SecondhandOffersRetrieveRequestParams {
  /** A unique integer value identifying this offer. */
  id: string;
}

export interface SecondhandOffersSubscriptionsRetrieveRequestParams {
  /** A unique integer value identifying this offer. */
  id: string;
}

export interface SecondhandOffersUpdateRequestParams {
  /** A unique integer value identifying this offer. */
  id: string;
  DeckOfferRequest: DeckOfferRequest;
}

export interface SecondhandSubscriptionsListRequestParams {
  /** Created after [YYYY-MM-DD] */
  created_date_from?: string;
  /** Created before [YYYY-MM-DD] */
  created_date_to?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** Updated after [YYYY-MM-DD] */
  modified_date_from?: string;
  /** Updated before [YYYY-MM-DD] */
  modified_date_to?: string;
  offer_id?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** A search term. */
  search?: string;
  subscribed?: boolean;
  type?: 'BUY' | 'SELL' | null;
}

export interface SelfPublishDetailFileTypesRetrieveRequestParams {
  /** A unique integer value identifying this pitch self publish. */
  id: string;
}

export interface StatsExportInvestmentsListRequestParams {
  end_date: string;
  series: 'month' | 'quarter';
  start_date: string;
}

export interface UsersAmlCheckCreateRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
  DeckUserRequest: DeckUserRequest;
}

export interface UsersAmlCheckPartialUpdateRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
  PatchedDeckUserRequest?: PatchedDeckUserRequest;
}

export interface UsersBatchCustomerStatusPartialUpdateRequestParams {
  PatchedBatchCustomerStatusRequest?: PatchedBatchCustomerStatusRequest;
}

export interface UsersCreateRequestParams {
  DeckCreateUserRequest: DeckCreateUserRequest;
}

export interface UsersDownloadPepReportRetrieveRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
}

export interface UsersIdfyPnrCreateRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
}

export interface UsersListRequestParams {
  added_from?: string;
  added_to?: string;
  invested_amount_from?: number;
  invested_amount_to?: number;
  invested_vs_declared?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  /** email, last name and/or first name */
  name?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering */
  order_by?:
    | '-current_year_investment'
    | '-customer_status'
    | '-date_joined'
    | '-email'
    | '-kyc_declared'
    | '-last_name'
    | '-pep_status'
    | '-sum_investment'
    | 'current_year_investment'
    | 'customer_status'
    | 'date_joined'
    | 'email'
    | 'kyc_declared'
    | 'last_name'
    | 'pep_status'
    | 'sum_investment';
  phone?: string;
  social_auth_provider?: string;
}

export interface UsersPartialUpdateRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
  PatchedDeckUserProfileRequest?: PatchedDeckUserProfileRequest;
}

export interface UsersProfileRetrieveRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
}

export interface UsersResetPasswordCreateRequestParams {
  DeckUserRequest: DeckUserRequest;
}

export interface UsersRetrieveRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
}

export interface UsersSearchListRequestParams {
  /** Number of results to return per page. */
  limit?: number;
  /** search only by name */
  name?: string;
  /** pitch id - excludes users invited to given pitch */
  not_invited_to?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** last name, first name, email */
  search?: string;
}

export interface UsersUpdateRequestParams {
  /** A unique integer value identifying this user. */
  id: string;
  DeckUserProfileRequest: DeckUserProfileRequest;
}

@Injectable({
  providedIn: 'root'
})
export class DeckService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepCopyCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<BeneficialOwnerPEPCopyResponse>;
  public bankidBeneficialOwnerPepCopyCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<BeneficialOwnerPEPCopyResponse>>;
  public bankidBeneficialOwnerPepCopyCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<BeneficialOwnerPEPCopyResponse>>;
  public bankidBeneficialOwnerPepCopyCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling bankidBeneficialOwnerPepCopyCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/copy`;
    return this.httpClient.request<BeneficialOwnerPEPCopyResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepCopyInstanceCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyInstanceCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<BeneficialOwnerPEP>;
  public bankidBeneficialOwnerPepCopyInstanceCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyInstanceCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<BeneficialOwnerPEP>>;
  public bankidBeneficialOwnerPepCopyInstanceCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyInstanceCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<BeneficialOwnerPEP>>;
  public bankidBeneficialOwnerPepCopyInstanceCreate(
    requestParameters?: BankidBeneficialOwnerPepCopyInstanceCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling bankidBeneficialOwnerPepCopyInstanceCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/copy_instance`;
    return this.httpClient.request<BeneficialOwnerPEP>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepDeckCopyInstanceCreate(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<BeneficialOwnerPEPCopyResponse>;
  public bankidBeneficialOwnerPepDeckCopyInstanceCreate(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<BeneficialOwnerPEPCopyResponse>>;
  public bankidBeneficialOwnerPepDeckCopyInstanceCreate(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<BeneficialOwnerPEPCopyResponse>>;
  public bankidBeneficialOwnerPepDeckCopyInstanceCreate(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/deck_copy_instance`;
    return this.httpClient.request<BeneficialOwnerPEPCopyResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepLatestList(
    requestParameters?: BankidBeneficialOwnerPepLatestListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedBeneficialOwnerPEPList>;
  public bankidBeneficialOwnerPepLatestList(
    requestParameters?: BankidBeneficialOwnerPepLatestListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedBeneficialOwnerPEPList>>;
  public bankidBeneficialOwnerPepLatestList(
    requestParameters?: BankidBeneficialOwnerPepLatestListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedBeneficialOwnerPEPList>>;
  public bankidBeneficialOwnerPepLatestList(
    requestParameters?: BankidBeneficialOwnerPepLatestListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const company_id = requestParameters?.company_id;
    const investment_company_id = requestParameters?.investment_company_id;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const status = requestParameters?.status;
    const status_unwanted = requestParameters?.status_unwanted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (investment_company_id !== undefined && investment_company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>investment_company_id, 'investment_company_id');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (status_unwanted) {
      status_unwanted.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status_unwanted');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/latest`;
    return this.httpClient.request<PaginatedBeneficialOwnerPEPList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepList(
    requestParameters?: BankidBeneficialOwnerPepListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedBeneficialOwnerPEPList>;
  public bankidBeneficialOwnerPepList(
    requestParameters?: BankidBeneficialOwnerPepListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedBeneficialOwnerPEPList>>;
  public bankidBeneficialOwnerPepList(
    requestParameters?: BankidBeneficialOwnerPepListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedBeneficialOwnerPEPList>>;
  public bankidBeneficialOwnerPepList(
    requestParameters?: BankidBeneficialOwnerPepListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const company_id = requestParameters?.company_id;
    const investment_company_id = requestParameters?.investment_company_id;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const status = requestParameters?.status;
    const status_unwanted = requestParameters?.status_unwanted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (investment_company_id !== undefined && investment_company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>investment_company_id, 'investment_company_id');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (status_unwanted) {
      status_unwanted.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status_unwanted');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep`;
    return this.httpClient.request<PaginatedBeneficialOwnerPEPList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepPartialUpdate(
    requestParameters?: BankidBeneficialOwnerPepPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<BeneficialOwnerPEPUpdate>;
  public bankidBeneficialOwnerPepPartialUpdate(
    requestParameters?: BankidBeneficialOwnerPepPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<BeneficialOwnerPEPUpdate>>;
  public bankidBeneficialOwnerPepPartialUpdate(
    requestParameters?: BankidBeneficialOwnerPepPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<BeneficialOwnerPEPUpdate>>;
  public bankidBeneficialOwnerPepPartialUpdate(
    requestParameters?: BankidBeneficialOwnerPepPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling bankidBeneficialOwnerPepPartialUpdate.');
    }
    const PatchedBeneficialOwnerPEPUpdateRequest = requestParameters?.PatchedBeneficialOwnerPEPUpdateRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<BeneficialOwnerPEPUpdate>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedBeneficialOwnerPEPUpdateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepReportLinkRetrieve(
    requestParameters?: BankidBeneficialOwnerPepReportLinkRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public bankidBeneficialOwnerPepReportLinkRetrieve(
    requestParameters?: BankidBeneficialOwnerPepReportLinkRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public bankidBeneficialOwnerPepReportLinkRetrieve(
    requestParameters?: BankidBeneficialOwnerPepReportLinkRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public bankidBeneficialOwnerPepReportLinkRetrieve(
    requestParameters?: BankidBeneficialOwnerPepReportLinkRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling bankidBeneficialOwnerPepReportLinkRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/report_link`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerPepUpdate(
    requestParameters?: BankidBeneficialOwnerPepUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<BeneficialOwnerPEPUpdate>;
  public bankidBeneficialOwnerPepUpdate(
    requestParameters?: BankidBeneficialOwnerPepUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<BeneficialOwnerPEPUpdate>>;
  public bankidBeneficialOwnerPepUpdate(
    requestParameters?: BankidBeneficialOwnerPepUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<BeneficialOwnerPEPUpdate>>;
  public bankidBeneficialOwnerPepUpdate(
    requestParameters?: BankidBeneficialOwnerPepUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling bankidBeneficialOwnerPepUpdate.');
    }
    const BeneficialOwnerPEPUpdateRequest = requestParameters?.BeneficialOwnerPEPUpdateRequest;
    if (BeneficialOwnerPEPUpdateRequest === null || BeneficialOwnerPEPUpdateRequest === undefined) {
      throw new Error(
        'Required parameter BeneficialOwnerPEPUpdateRequest was null or undefined when calling bankidBeneficialOwnerPepUpdate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial-owner-pep/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<BeneficialOwnerPEPUpdate>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: BeneficialOwnerPEPUpdateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidBeneficialOwnerRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public bankidBeneficialOwnerRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public bankidBeneficialOwnerRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public bankidBeneficialOwnerRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/beneficial_owner`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidPepCheckLatestList(
    requestParameters?: BankidPepCheckLatestListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedIndividualPEPList>;
  public bankidPepCheckLatestList(
    requestParameters?: BankidPepCheckLatestListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedIndividualPEPList>>;
  public bankidPepCheckLatestList(
    requestParameters?: BankidPepCheckLatestListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedIndividualPEPList>>;
  public bankidPepCheckLatestList(
    requestParameters?: BankidPepCheckLatestListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const status = requestParameters?.status;
    const status_unwanted = requestParameters?.status_unwanted;
    const user_id = requestParameters?.user_id;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (status_unwanted) {
      status_unwanted.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status_unwanted');
      });
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/pep-check/latest`;
    return this.httpClient.request<PaginatedIndividualPEPList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidPepCheckList(
    requestParameters?: BankidPepCheckListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedIndividualPEPList>;
  public bankidPepCheckList(
    requestParameters?: BankidPepCheckListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedIndividualPEPList>>;
  public bankidPepCheckList(
    requestParameters?: BankidPepCheckListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedIndividualPEPList>>;
  public bankidPepCheckList(
    requestParameters?: BankidPepCheckListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const status = requestParameters?.status;
    const status_unwanted = requestParameters?.status_unwanted;
    const user_id = requestParameters?.user_id;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (status_unwanted) {
      status_unwanted.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status_unwanted');
      });
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/pep-check`;
    return this.httpClient.request<PaginatedIndividualPEPList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidPepCheckManualCreate(
    requestParameters?: BankidPepCheckManualCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<IndividualPEP>;
  public bankidPepCheckManualCreate(
    requestParameters?: BankidPepCheckManualCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<IndividualPEP>>;
  public bankidPepCheckManualCreate(
    requestParameters?: BankidPepCheckManualCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<IndividualPEP>>;
  public bankidPepCheckManualCreate(
    requestParameters?: BankidPepCheckManualCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const IndividualPEPRequest = requestParameters?.IndividualPEPRequest;
    if (IndividualPEPRequest === null || IndividualPEPRequest === undefined) {
      throw new Error('Required parameter IndividualPEPRequest was null or undefined when calling bankidPepCheckManualCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/pep-check/manual`;
    return this.httpClient.request<IndividualPEP>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: IndividualPEPRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public bankidReportRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public bankidReportRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public bankidReportRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public bankidReportRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/bankid/report`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesAmlCheckCreate(
    requestParameters?: CompaniesAmlCheckCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesAmlCheckCreate(
    requestParameters?: CompaniesAmlCheckCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesAmlCheckCreate(
    requestParameters?: CompaniesAmlCheckCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesAmlCheckCreate(
    requestParameters?: CompaniesAmlCheckCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companiesAmlCheckCreate.');
    }
    const DeckCompanyDetailRequest = requestParameters?.DeckCompanyDetailRequest;
    if (DeckCompanyDetailRequest === null || DeckCompanyDetailRequest === undefined) {
      throw new Error('Required parameter DeckCompanyDetailRequest was null or undefined when calling companiesAmlCheckCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckCompanyDetail>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckCompanyDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesAmlCheckPartialUpdate(
    requestParameters?: CompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesAmlCheckPartialUpdate(
    requestParameters?: CompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesAmlCheckPartialUpdate(
    requestParameters?: CompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesAmlCheckPartialUpdate(
    requestParameters?: CompaniesAmlCheckPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companiesAmlCheckPartialUpdate.');
    }
    const PatchedDeckCompanyDetailRequest = requestParameters?.PatchedDeckCompanyDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckCompanyDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckCompanyDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesCreate(
    requestParameters?: CompaniesCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesCreate(
    requestParameters?: CompaniesCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesCreate(
    requestParameters?: CompaniesCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesCreate(
    requestParameters?: CompaniesCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckCompanyDetailRequest = requestParameters?.DeckCompanyDetailRequest;
    if (DeckCompanyDetailRequest === null || DeckCompanyDetailRequest === undefined) {
      throw new Error('Required parameter DeckCompanyDetailRequest was null or undefined when calling companiesCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies`;
    return this.httpClient.request<DeckCompanyDetail>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckCompanyDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesList(
    requestParameters?: CompaniesListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckCompanyListList>;
  public companiesList(
    requestParameters?: CompaniesListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckCompanyListList>>;
  public companiesList(
    requestParameters?: CompaniesListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckCompanyListList>>;
  public companiesList(
    requestParameters?: CompaniesListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies`;
    return this.httpClient.request<PaginatedDeckCompanyListList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesPartialUpdate(
    requestParameters?: CompaniesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesPartialUpdate(
    requestParameters?: CompaniesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesPartialUpdate(
    requestParameters?: CompaniesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesPartialUpdate(
    requestParameters?: CompaniesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companiesPartialUpdate.');
    }
    const PatchedDeckCompanyDetailRequest = requestParameters?.PatchedDeckCompanyDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckCompanyDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckCompanyDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesRetrieve(
    requestParameters?: CompaniesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesRetrieve(
    requestParameters?: CompaniesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesRetrieve(
    requestParameters?: CompaniesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesRetrieve(
    requestParameters?: CompaniesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companiesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckCompanyDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Company model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companiesUpdate(
    requestParameters?: CompaniesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCompanyDetail>;
  public companiesUpdate(
    requestParameters?: CompaniesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCompanyDetail>>;
  public companiesUpdate(
    requestParameters?: CompaniesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCompanyDetail>>;
  public companiesUpdate(
    requestParameters?: CompaniesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companiesUpdate.');
    }
    const DeckCompanyDetailRequest = requestParameters?.DeckCompanyDetailRequest;
    if (DeckCompanyDetailRequest === null || DeckCompanyDetailRequest === undefined) {
      throw new Error('Required parameter DeckCompanyDetailRequest was null or undefined when calling companiesUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckCompanyDetail>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckCompanyDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companyRequestsList(
    requestParameters?: CompanyRequestsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedCompanyJoinRequestsList>;
  public companyRequestsList(
    requestParameters?: CompanyRequestsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedCompanyJoinRequestsList>>;
  public companyRequestsList(
    requestParameters?: CompanyRequestsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedCompanyJoinRequestsList>>;
  public companyRequestsList(
    requestParameters?: CompanyRequestsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const search = requestParameters?.search;
    const status = requestParameters?.status;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>status, 'status');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/company/requests`;
    return this.httpClient.request<PaginatedCompanyJoinRequestsList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companyRequestsPartialUpdate(
    requestParameters?: CompanyRequestsPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CompanyJoinRequests>;
  public companyRequestsPartialUpdate(
    requestParameters?: CompanyRequestsPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CompanyJoinRequests>>;
  public companyRequestsPartialUpdate(
    requestParameters?: CompanyRequestsPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CompanyJoinRequests>>;
  public companyRequestsPartialUpdate(
    requestParameters?: CompanyRequestsPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companyRequestsPartialUpdate.');
    }
    const PatchedCompanyJoinRequestsRequest = requestParameters?.PatchedCompanyJoinRequestsRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/company/requests/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CompanyJoinRequests>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedCompanyJoinRequestsRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companyRequestsRetrieve(
    requestParameters?: CompanyRequestsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CompanyJoinRequests>;
  public companyRequestsRetrieve(
    requestParameters?: CompanyRequestsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CompanyJoinRequests>>;
  public companyRequestsRetrieve(
    requestParameters?: CompanyRequestsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CompanyJoinRequests>>;
  public companyRequestsRetrieve(
    requestParameters?: CompanyRequestsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companyRequestsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/company/requests/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CompanyJoinRequests>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public companyRequestsUpdate(
    requestParameters?: CompanyRequestsUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CompanyJoinRequests>;
  public companyRequestsUpdate(
    requestParameters?: CompanyRequestsUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CompanyJoinRequests>>;
  public companyRequestsUpdate(
    requestParameters?: CompanyRequestsUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CompanyJoinRequests>>;
  public companyRequestsUpdate(
    requestParameters?: CompanyRequestsUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling companyRequestsUpdate.');
    }
    const CompanyJoinRequestsRequest = requestParameters?.CompanyJoinRequestsRequest;
    if (CompanyJoinRequestsRequest === null || CompanyJoinRequestsRequest === undefined) {
      throw new Error('Required parameter CompanyJoinRequestsRequest was null or undefined when calling companyRequestsUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/company/requests/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CompanyJoinRequests>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: CompanyJoinRequestsRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contactUsList(
    requestParameters?: ContactUsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckContactUsList>;
  public contactUsList(
    requestParameters?: ContactUsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckContactUsList>>;
  public contactUsList(
    requestParameters?: ContactUsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckContactUsList>>;
  public contactUsList(
    requestParameters?: ContactUsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const filter = requestParameters?.filter;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (filter !== undefined && filter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/contact-us`;
    return this.httpClient.request<PaginatedDeckContactUsList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contactUsRetrieve(
    requestParameters?: ContactUsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckContactUs>;
  public contactUsRetrieve(
    requestParameters?: ContactUsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckContactUs>>;
  public contactUsRetrieve(
    requestParameters?: ContactUsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckContactUs>>;
  public contactUsRetrieve(
    requestParameters?: ContactUsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling contactUsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/contact-us/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckContactUs>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for uploading, downloading and deleting files
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dealflowFilesCreate(
    requestParameters?: DealflowFilesCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CreateFile>;
  public dealflowFilesCreate(
    requestParameters?: DealflowFilesCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CreateFile>>;
  public dealflowFilesCreate(
    requestParameters?: DealflowFilesCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CreateFile>>;
  public dealflowFilesCreate(
    requestParameters?: DealflowFilesCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const CreateFileRequest = requestParameters?.CreateFileRequest;
    if (CreateFileRequest === null || CreateFileRequest === undefined) {
      throw new Error('Required parameter CreateFileRequest was null or undefined when calling dealflowFilesCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/dealflow-files`;
    return this.httpClient.request<CreateFile>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: CreateFileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for uploading, downloading and deleting files
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dealflowFilesDestroy(
    requestParameters?: DealflowFilesDestroyRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any>;
  public dealflowFilesDestroy(
    requestParameters?: DealflowFilesDestroyRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public dealflowFilesDestroy(
    requestParameters?: DealflowFilesDestroyRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public dealflowFilesDestroy(
    requestParameters?: DealflowFilesDestroyRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling dealflowFilesDestroy.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/dealflow-files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for uploading, downloading and deleting files
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dealflowFilesPartialUpdate(
    requestParameters?: DealflowFilesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DealflowFile>;
  public dealflowFilesPartialUpdate(
    requestParameters?: DealflowFilesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DealflowFile>>;
  public dealflowFilesPartialUpdate(
    requestParameters?: DealflowFilesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DealflowFile>>;
  public dealflowFilesPartialUpdate(
    requestParameters?: DealflowFilesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling dealflowFilesPartialUpdate.');
    }
    const PatchedDealflowFileRequest = requestParameters?.PatchedDealflowFileRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/dealflow-files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DealflowFile>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDealflowFileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for uploading, downloading and deleting files
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dealflowFilesRetrieve(
    requestParameters?: DealflowFilesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<FileLink>;
  public dealflowFilesRetrieve(
    requestParameters?: DealflowFilesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<FileLink>>;
  public dealflowFilesRetrieve(
    requestParameters?: DealflowFilesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<FileLink>>;
  public dealflowFilesRetrieve(
    requestParameters?: DealflowFilesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling dealflowFilesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/dealflow-files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<FileLink>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for uploading, downloading and deleting files
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dealflowFilesUpdate(
    requestParameters?: DealflowFilesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CreateFile>;
  public dealflowFilesUpdate(
    requestParameters?: DealflowFilesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CreateFile>>;
  public dealflowFilesUpdate(
    requestParameters?: DealflowFilesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CreateFile>>;
  public dealflowFilesUpdate(
    requestParameters?: DealflowFilesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling dealflowFilesUpdate.');
    }
    const CreateFileRequest = requestParameters?.CreateFileRequest;
    if (CreateFileRequest === null || CreateFileRequest === undefined) {
      throw new Error('Required parameter CreateFileRequest was null or undefined when calling dealflowFilesUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/dealflow-files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CreateFile>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: CreateFileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Update paid flag in many investment objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchPaidPartialUpdate(
    requestParameters?: InvestmentBatchPaidPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchPaidPartialUpdate(
    requestParameters?: InvestmentBatchPaidPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchPaidPartialUpdate(
    requestParameters?: InvestmentBatchPaidPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchPaidPartialUpdate(
    requestParameters?: InvestmentBatchPaidPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-paid`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Update paid flag in many investment objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchPaidUpdate(
    requestParameters?: InvestmentBatchPaidUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchPaidUpdate(
    requestParameters?: InvestmentBatchPaidUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchPaidUpdate(
    requestParameters?: InvestmentBatchPaidUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchPaidUpdate(
    requestParameters?: InvestmentBatchPaidUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckDetailInvestmentRequest = requestParameters?.DeckDetailInvestmentRequest;
    if (DeckDetailInvestmentRequest === null || DeckDetailInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckDetailInvestmentRequest was null or undefined when calling investmentBatchPaidUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-paid`;
    return this.httpClient.request<DeckDetailInvestment>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Update number of shares.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchSharesPartialUpdate(
    requestParameters?: InvestmentBatchSharesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchSharesPartialUpdate(
    requestParameters?: InvestmentBatchSharesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchSharesPartialUpdate(
    requestParameters?: InvestmentBatchSharesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchSharesPartialUpdate(
    requestParameters?: InvestmentBatchSharesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-shares`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Update number of shares.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchSharesUpdate(
    requestParameters?: InvestmentBatchSharesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchSharesUpdate(
    requestParameters?: InvestmentBatchSharesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchSharesUpdate(
    requestParameters?: InvestmentBatchSharesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchSharesUpdate(
    requestParameters?: InvestmentBatchSharesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckDetailInvestmentRequest = requestParameters?.DeckDetailInvestmentRequest;
    if (DeckDetailInvestmentRequest === null || DeckDetailInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckDetailInvestmentRequest was null or undefined when calling investmentBatchSharesUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-shares`;
    return this.httpClient.request<DeckDetailInvestment>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Modifies the state of the status to received string on multiple objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchStatusPartialUpdate(
    requestParameters?: InvestmentBatchStatusPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchStatusPartialUpdate(
    requestParameters?: InvestmentBatchStatusPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchStatusPartialUpdate(
    requestParameters?: InvestmentBatchStatusPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchStatusPartialUpdate(
    requestParameters?: InvestmentBatchStatusPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-status`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Modifies the state of the status to received string on multiple objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentBatchStatusUpdate(
    requestParameters?: InvestmentBatchStatusUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentBatchStatusUpdate(
    requestParameters?: InvestmentBatchStatusUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentBatchStatusUpdate(
    requestParameters?: InvestmentBatchStatusUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentBatchStatusUpdate(
    requestParameters?: InvestmentBatchStatusUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckDetailInvestmentRequest = requestParameters?.DeckDetailInvestmentRequest;
    if (DeckDetailInvestmentRequest === null || DeckDetailInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckDetailInvestmentRequest was null or undefined when calling investmentBatchStatusUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/batch-status`;
    return this.httpClient.request<DeckDetailInvestment>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesAmlCheckCreate(
    requestParameters?: InvestmentCompaniesAmlCheckCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompany>;
  public investmentCompaniesAmlCheckCreate(
    requestParameters?: InvestmentCompaniesAmlCheckCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompany>>;
  public investmentCompaniesAmlCheckCreate(
    requestParameters?: InvestmentCompaniesAmlCheckCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompany>>;
  public investmentCompaniesAmlCheckCreate(
    requestParameters?: InvestmentCompaniesAmlCheckCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesAmlCheckCreate.');
    }
    const DeckInvestmentCompanyRequest = requestParameters?.DeckInvestmentCompanyRequest;
    if (DeckInvestmentCompanyRequest === null || DeckInvestmentCompanyRequest === undefined) {
      throw new Error(
        'Required parameter DeckInvestmentCompanyRequest was null or undefined when calling investmentCompaniesAmlCheckCreate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckInvestmentCompany>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckInvestmentCompanyRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesAmlCheckPartialUpdate(
    requestParameters?: InvestmentCompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompany>;
  public investmentCompaniesAmlCheckPartialUpdate(
    requestParameters?: InvestmentCompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompany>>;
  public investmentCompaniesAmlCheckPartialUpdate(
    requestParameters?: InvestmentCompaniesAmlCheckPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompany>>;
  public investmentCompaniesAmlCheckPartialUpdate(
    requestParameters?: InvestmentCompaniesAmlCheckPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesAmlCheckPartialUpdate.');
    }
    const PatchedDeckInvestmentCompanyRequest = requestParameters?.PatchedDeckInvestmentCompanyRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckInvestmentCompany>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckInvestmentCompanyRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Sets a value of red flag for the companies whose id are provided.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesBatchRedPartialUpdate(
    requestParameters?: InvestmentCompaniesBatchRedPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompany>;
  public investmentCompaniesBatchRedPartialUpdate(
    requestParameters?: InvestmentCompaniesBatchRedPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompany>>;
  public investmentCompaniesBatchRedPartialUpdate(
    requestParameters?: InvestmentCompaniesBatchRedPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompany>>;
  public investmentCompaniesBatchRedPartialUpdate(
    requestParameters?: InvestmentCompaniesBatchRedPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const body = requestParameters?.body;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['red'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/batch-red`;
    return this.httpClient.request<DeckInvestmentCompany>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesCreate(
    requestParameters?: InvestmentCompaniesCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompanyCreate>;
  public investmentCompaniesCreate(
    requestParameters?: InvestmentCompaniesCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesCreate(
    requestParameters?: InvestmentCompaniesCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesCreate(
    requestParameters?: InvestmentCompaniesCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckInvestmentCompanyCreateRequest = requestParameters?.DeckInvestmentCompanyCreateRequest;
    if (DeckInvestmentCompanyCreateRequest === null || DeckInvestmentCompanyCreateRequest === undefined) {
      throw new Error(
        'Required parameter DeckInvestmentCompanyCreateRequest was null or undefined when calling investmentCompaniesCreate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies`;
    return this.httpClient.request<DeckInvestmentCompanyCreate>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckInvestmentCompanyCreateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesDownloadAgreementRetrieve(
    requestParameters?: InvestmentCompaniesDownloadAgreementRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public investmentCompaniesDownloadAgreementRetrieve(
    requestParameters?: InvestmentCompaniesDownloadAgreementRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public investmentCompaniesDownloadAgreementRetrieve(
    requestParameters?: InvestmentCompaniesDownloadAgreementRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public investmentCompaniesDownloadAgreementRetrieve(
    requestParameters?: InvestmentCompaniesDownloadAgreementRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesDownloadAgreementRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/download-agreement`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesList(
    requestParameters?: InvestmentCompaniesListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckInvestmentCompanyList>;
  public investmentCompaniesList(
    requestParameters?: InvestmentCompaniesListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckInvestmentCompanyList>>;
  public investmentCompaniesList(
    requestParameters?: InvestmentCompaniesListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckInvestmentCompanyList>>;
  public investmentCompaniesList(
    requestParameters?: InvestmentCompaniesListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const user_id = requestParameters?.user_id;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies`;
    return this.httpClient.request<PaginatedDeckInvestmentCompanyList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesPartialUpdate(
    requestParameters?: InvestmentCompaniesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompanyCreate>;
  public investmentCompaniesPartialUpdate(
    requestParameters?: InvestmentCompaniesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesPartialUpdate(
    requestParameters?: InvestmentCompaniesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesPartialUpdate(
    requestParameters?: InvestmentCompaniesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesPartialUpdate.');
    }
    const PatchedDeckInvestmentCompanyCreateRequest = requestParameters?.PatchedDeckInvestmentCompanyCreateRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckInvestmentCompanyCreate>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckInvestmentCompanyCreateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesRetrieve(
    requestParameters?: InvestmentCompaniesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompanyDetail>;
  public investmentCompaniesRetrieve(
    requestParameters?: InvestmentCompaniesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompanyDetail>>;
  public investmentCompaniesRetrieve(
    requestParameters?: InvestmentCompaniesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompanyDetail>>;
  public investmentCompaniesRetrieve(
    requestParameters?: InvestmentCompaniesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckInvestmentCompanyDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesSaveAgreementCreate(
    requestParameters?: InvestmentCompaniesSaveAgreementCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompany>;
  public investmentCompaniesSaveAgreementCreate(
    requestParameters?: InvestmentCompaniesSaveAgreementCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompany>>;
  public investmentCompaniesSaveAgreementCreate(
    requestParameters?: InvestmentCompaniesSaveAgreementCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompany>>;
  public investmentCompaniesSaveAgreementCreate(
    requestParameters?: InvestmentCompaniesSaveAgreementCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesSaveAgreementCreate.');
    }
    const DeckInvestmentCompanyRequest = requestParameters?.DeckInvestmentCompanyRequest;
    if (DeckInvestmentCompanyRequest === null || DeckInvestmentCompanyRequest === undefined) {
      throw new Error(
        'Required parameter DeckInvestmentCompanyRequest was null or undefined when calling investmentCompaniesSaveAgreementCreate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/save-agreement`;
    return this.httpClient.request<DeckInvestmentCompany>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckInvestmentCompanyRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for InvestmentCompany model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesUpdate(
    requestParameters?: InvestmentCompaniesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckInvestmentCompanyCreate>;
  public investmentCompaniesUpdate(
    requestParameters?: InvestmentCompaniesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesUpdate(
    requestParameters?: InvestmentCompaniesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckInvestmentCompanyCreate>>;
  public investmentCompaniesUpdate(
    requestParameters?: InvestmentCompaniesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesUpdate.');
    }
    const DeckInvestmentCompanyCreateRequest = requestParameters?.DeckInvestmentCompanyCreateRequest;
    if (DeckInvestmentCompanyCreateRequest === null || DeckInvestmentCompanyCreateRequest === undefined) {
      throw new Error(
        'Required parameter DeckInvestmentCompanyCreateRequest was null or undefined when calling investmentCompaniesUpdate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckInvestmentCompanyCreate>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckInvestmentCompanyCreateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Returns list of users related to investment company. Filters by id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCompaniesUsersList(
    requestParameters?: InvestmentCompaniesUsersListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckSimpleUserList>;
  public investmentCompaniesUsersList(
    requestParameters?: InvestmentCompaniesUsersListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckSimpleUserList>>;
  public investmentCompaniesUsersList(
    requestParameters?: InvestmentCompaniesUsersListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckSimpleUserList>>;
  public investmentCompaniesUsersList(
    requestParameters?: InvestmentCompaniesUsersListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentCompaniesUsersList.');
    }
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment-companies/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/users`;
    return this.httpClient.request<PaginatedDeckSimpleUserList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentCreate(
    requestParameters?: InvestmentCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentCreate(
    requestParameters?: InvestmentCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentCreate(
    requestParameters?: InvestmentCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentCreate(
    requestParameters?: InvestmentCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckDetailInvestmentRequest = requestParameters?.DeckDetailInvestmentRequest;
    if (DeckDetailInvestmentRequest === null || DeckDetailInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckDetailInvestmentRequest was null or undefined when calling investmentCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment`;
    return this.httpClient.request<DeckDetailInvestment>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentDownloadAgreementRetrieve(
    requestParameters?: InvestmentDownloadAgreementRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentDownloadAgreementRetrieve(
    requestParameters?: InvestmentDownloadAgreementRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentDownloadAgreementRetrieve(
    requestParameters?: InvestmentDownloadAgreementRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentDownloadAgreementRetrieve(
    requestParameters?: InvestmentDownloadAgreementRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentDownloadAgreementRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/download-agreement`;
    return this.httpClient.request<DeckDetailInvestment>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentInvestOnBehalfCreate(
    requestParameters?: InvestmentInvestOnBehalfCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCreateInvestment>;
  public investmentInvestOnBehalfCreate(
    requestParameters?: InvestmentInvestOnBehalfCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCreateInvestment>>;
  public investmentInvestOnBehalfCreate(
    requestParameters?: InvestmentInvestOnBehalfCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCreateInvestment>>;
  public investmentInvestOnBehalfCreate(
    requestParameters?: InvestmentInvestOnBehalfCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckCreateInvestmentRequest = requestParameters?.DeckCreateInvestmentRequest;
    if (DeckCreateInvestmentRequest === null || DeckCreateInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckCreateInvestmentRequest was null or undefined when calling investmentInvestOnBehalfCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/invest-on-behalf`;
    return this.httpClient.request<DeckCreateInvestment>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckCreateInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentList(
    requestParameters?: InvestmentListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckDetailInvestmentList>;
  public investmentList(
    requestParameters?: InvestmentListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckDetailInvestmentList>>;
  public investmentList(
    requestParameters?: InvestmentListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckDetailInvestmentList>>;
  public investmentList(
    requestParameters?: InvestmentListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const added_from = requestParameters?.added_from;
    const added_to = requestParameters?.added_to;
    const agreement_idfy_id = requestParameters?.agreement_idfy_id;
    const amount_from = requestParameters?.amount_from;
    const amount_to = requestParameters?.amount_to;
    const customer_status = requestParameters?.customer_status;
    const email = requestParameters?.email;
    const investment_company_id = requestParameters?.investment_company_id;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const payment_option = requestParameters?.payment_option;
    const pitch_id = requestParameters?.pitch_id;
    const pitch_name = requestParameters?.pitch_name;
    const search = requestParameters?.search;
    const status = requestParameters?.status;
    const unwanted_status = requestParameters?.unwanted_status;
    const user_id = requestParameters?.user_id;
    const username = requestParameters?.username;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (added_from !== undefined && added_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_from, 'added_from');
    }
    if (added_to !== undefined && added_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_to, 'added_to');
    }
    if (agreement_idfy_id !== undefined && agreement_idfy_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>agreement_idfy_id, 'agreement_idfy_id');
    }
    if (amount_from !== undefined && amount_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>amount_from, 'amount_from');
    }
    if (amount_to !== undefined && amount_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>amount_to, 'amount_to');
    }
    if (customer_status !== undefined && customer_status !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>customer_status, 'customer_status');
    }
    if (email !== undefined && email !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>email, 'email');
    }
    if (investment_company_id !== undefined && investment_company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>investment_company_id, 'investment_company_id');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (payment_option !== undefined && payment_option !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>payment_option, 'payment_option');
    }
    if (pitch_id !== undefined && pitch_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch_id, 'pitch_id');
    }
    if (pitch_name !== undefined && pitch_name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch_name, 'pitch_name');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (unwanted_status) {
      unwanted_status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'unwanted_status');
      });
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }
    if (username !== undefined && username !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>username, 'username');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment`;
    return this.httpClient.request<PaginatedDeckDetailInvestmentList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switch the value of field &#x60;paid&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentPaidPartialUpdate(
    requestParameters?: InvestmentPaidPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentPaidPartialUpdate(
    requestParameters?: InvestmentPaidPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentPaidPartialUpdate(
    requestParameters?: InvestmentPaidPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentPaidPartialUpdate(
    requestParameters?: InvestmentPaidPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentPaidPartialUpdate.');
    }
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/paid`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switch the value of field &#x60;paid&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentPaidUpdate(
    requestParameters?: InvestmentPaidUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentPaidUpdate(
    requestParameters?: InvestmentPaidUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentPaidUpdate(
    requestParameters?: InvestmentPaidUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentPaidUpdate(
    requestParameters?: InvestmentPaidUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentPaidUpdate.');
    }
    const DeckDetailInvestmentRequest = requestParameters?.DeckDetailInvestmentRequest;
    if (DeckDetailInvestmentRequest === null || DeckDetailInvestmentRequest === undefined) {
      throw new Error('Required parameter DeckDetailInvestmentRequest was null or undefined when calling investmentPaidUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/paid`;
    return this.httpClient.request<DeckDetailInvestment>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentRejectionReasonsRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckRejectionReason>;
  public investmentRejectionReasonsRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckRejectionReason>>;
  public investmentRejectionReasonsRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckRejectionReason>>;
  public investmentRejectionReasonsRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/rejection-reasons`;
    return this.httpClient.request<DeckRejectionReason>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentRetrieve(
    requestParameters?: InvestmentRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentRetrieve(
    requestParameters?: InvestmentRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentRetrieve(
    requestParameters?: InvestmentRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentRetrieve(
    requestParameters?: InvestmentRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling investmentRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckDetailInvestment>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentSendPaymentSlipPartialUpdate(
    requestParameters?: InvestmentSendPaymentSlipPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentSendPaymentSlipPartialUpdate(
    requestParameters?: InvestmentSendPaymentSlipPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentSendPaymentSlipPartialUpdate(
    requestParameters?: InvestmentSendPaymentSlipPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentSendPaymentSlipPartialUpdate(
    requestParameters?: InvestmentSendPaymentSlipPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/send-payment-slip`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public investmentSendToAcceptedPartialUpdate(
    requestParameters?: InvestmentSendToAcceptedPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckDetailInvestment>;
  public investmentSendToAcceptedPartialUpdate(
    requestParameters?: InvestmentSendToAcceptedPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckDetailInvestment>>;
  public investmentSendToAcceptedPartialUpdate(
    requestParameters?: InvestmentSendToAcceptedPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckDetailInvestment>>;
  public investmentSendToAcceptedPartialUpdate(
    requestParameters?: InvestmentSendToAcceptedPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckDetailInvestmentRequest = requestParameters?.PatchedDeckDetailInvestmentRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/investment/send-to-accepted`;
    return this.httpClient.request<DeckDetailInvestment>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckDetailInvestmentRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switches the state of handled flag.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listingsHandledPartialUpdate(
    requestParameters?: ListingsHandledPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckListings>;
  public listingsHandledPartialUpdate(
    requestParameters?: ListingsHandledPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckListings>>;
  public listingsHandledPartialUpdate(
    requestParameters?: ListingsHandledPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckListings>>;
  public listingsHandledPartialUpdate(
    requestParameters?: ListingsHandledPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling listingsHandledPartialUpdate.');
    }
    const PatchedDeckListingsRequest = requestParameters?.PatchedDeckListingsRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/listings/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/handled`;
    return this.httpClient.request<DeckListings>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckListingsRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listingsList(
    requestParameters?: ListingsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckListingsList>;
  public listingsList(
    requestParameters?: ListingsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckListingsList>>;
  public listingsList(
    requestParameters?: ListingsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckListingsList>>;
  public listingsList(
    requestParameters?: ListingsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/listings`;
    return this.httpClient.request<PaginatedDeckListingsList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listingsRetrieve(
    requestParameters?: ListingsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckListings>;
  public listingsRetrieve(
    requestParameters?: ListingsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckListings>>;
  public listingsRetrieve(
    requestParameters?: ListingsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckListings>>;
  public listingsRetrieve(
    requestParameters?: ListingsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling listingsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/listings/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckListings>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pepcheckManualCreate(
    requestParameters?: PepcheckManualCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CreatePepCheck>;
  public pepcheckManualCreate(
    requestParameters?: PepcheckManualCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CreatePepCheck>>;
  public pepcheckManualCreate(
    requestParameters?: PepcheckManualCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CreatePepCheck>>;
  public pepcheckManualCreate(
    requestParameters?: PepcheckManualCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const CreatePepCheckRequest = requestParameters?.CreatePepCheckRequest;
    if (CreatePepCheckRequest === null || CreatePepCheckRequest === undefined) {
      throw new Error('Required parameter CreatePepCheckRequest was null or undefined when calling pepcheckManualCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pepcheck/manual`;
    return this.httpClient.request<CreatePepCheck>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: CreatePepCheckRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pepcheckManualPartialUpdate(
    requestParameters?: PepcheckManualPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CreatePepCheck>;
  public pepcheckManualPartialUpdate(
    requestParameters?: PepcheckManualPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CreatePepCheck>>;
  public pepcheckManualPartialUpdate(
    requestParameters?: PepcheckManualPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CreatePepCheck>>;
  public pepcheckManualPartialUpdate(
    requestParameters?: PepcheckManualPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pepcheckManualPartialUpdate.');
    }
    const PatchedCreatePepCheckRequest = requestParameters?.PatchedCreatePepCheckRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pepcheck/manual/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CreatePepCheck>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedCreatePepCheckRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pepcheckManualUpdate(
    requestParameters?: PepcheckManualUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<CreatePepCheck>;
  public pepcheckManualUpdate(
    requestParameters?: PepcheckManualUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<CreatePepCheck>>;
  public pepcheckManualUpdate(
    requestParameters?: PepcheckManualUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<CreatePepCheck>>;
  public pepcheckManualUpdate(
    requestParameters?: PepcheckManualUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pepcheckManualUpdate.');
    }
    const CreatePepCheckRequest = requestParameters?.CreatePepCheckRequest;
    if (CreatePepCheckRequest === null || CreatePepCheckRequest === undefined) {
      throw new Error('Required parameter CreatePepCheckRequest was null or undefined when calling pepcheckManualUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pepcheck/manual/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<CreatePepCheck>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: CreatePepCheckRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchAcceptInvestmentsPartialUpdate(
    requestParameters?: PitchAcceptInvestmentsPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckInvestmentsList>;
  public pitchAcceptInvestmentsPartialUpdate(
    requestParameters?: PitchAcceptInvestmentsPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckInvestmentsList>>;
  public pitchAcceptInvestmentsPartialUpdate(
    requestParameters?: PitchAcceptInvestmentsPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckInvestmentsList>>;
  public pitchAcceptInvestmentsPartialUpdate(
    requestParameters?: PitchAcceptInvestmentsPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchAcceptInvestmentsPartialUpdate.');
    }
    const company_id = requestParameters?.company_id;
    const company_name = requestParameters?.company_name;
    const labels = requestParameters?.labels;
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const visibility = requestParameters?.visibility;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (company_name !== undefined && company_name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_name, 'company_name');
    }
    if (labels) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, [...labels].join(COLLECTION_FORMATS['csv']), 'labels');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (visibility) {
      visibility.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'visibility');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/accept-investments`;
    return this.httpClient.request<PaginatedDeckInvestmentsList>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchAcceptInvestmentsUpdate(
    requestParameters?: PitchAcceptInvestmentsUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckInvestmentsList>;
  public pitchAcceptInvestmentsUpdate(
    requestParameters?: PitchAcceptInvestmentsUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckInvestmentsList>>;
  public pitchAcceptInvestmentsUpdate(
    requestParameters?: PitchAcceptInvestmentsUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckInvestmentsList>>;
  public pitchAcceptInvestmentsUpdate(
    requestParameters?: PitchAcceptInvestmentsUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchAcceptInvestmentsUpdate.');
    }
    const company_id = requestParameters?.company_id;
    const company_name = requestParameters?.company_name;
    const labels = requestParameters?.labels;
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const visibility = requestParameters?.visibility;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (company_name !== undefined && company_name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_name, 'company_name');
    }
    if (labels) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, [...labels].join(COLLECTION_FORMATS['csv']), 'labels');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (visibility) {
      visibility.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'visibility');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/accept-investments`;
    return this.httpClient.request<PaginatedDeckInvestmentsList>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Create PitchInvitations for every sent emial and send emails with link to pitch. If user doesn\&#39;t exists then add registration link.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchBatchInviteCreate(
    requestParameters?: PitchBatchInviteCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchBatchInviteCreate(
    requestParameters?: PitchBatchInviteCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchBatchInviteCreate(
    requestParameters?: PitchBatchInviteCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchBatchInviteCreate(
    requestParameters?: PitchBatchInviteCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchBatchInviteCreate.');
    }
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchBatchInviteCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/batch-invite`;
    return this.httpClient.request<DeckPitchDetail>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchBatchStatusPartialUpdate(
    requestParameters?: PitchBatchStatusPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchBatchStatusPartialUpdate(
    requestParameters?: PitchBatchStatusPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchBatchStatusPartialUpdate(
    requestParameters?: PitchBatchStatusPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchBatchStatusPartialUpdate(
    requestParameters?: PitchBatchStatusPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckPitchDetailRequest = requestParameters?.PatchedDeckPitchDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/batch-status`;
    return this.httpClient.request<DeckPitchDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchBatchStatusUpdate(
    requestParameters?: PitchBatchStatusUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchBatchStatusUpdate(
    requestParameters?: PitchBatchStatusUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchBatchStatusUpdate(
    requestParameters?: PitchBatchStatusUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchBatchStatusUpdate(
    requestParameters?: PitchBatchStatusUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchBatchStatusUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/batch-status`;
    return this.httpClient.request<DeckPitchDetail>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchDownloadInvestmentsRetrieve(
    requestParameters?: PitchDownloadInvestmentsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchDownloadInvestmentsRetrieve(
    requestParameters?: PitchDownloadInvestmentsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchDownloadInvestmentsRetrieve(
    requestParameters?: PitchDownloadInvestmentsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchDownloadInvestmentsRetrieve(
    requestParameters?: PitchDownloadInvestmentsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchDownloadInvestmentsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/download-investments`;
    return this.httpClient.request<DeckPitchDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Export information about investments made on the pitch in a json format so it can be easily imported. Pass organization_number to add shares to that company. To update provide id or try by searching with allocation date and share_price.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchExportInvestmentsCreate(
    requestParameters?: PitchExportInvestmentsCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InvestmentsExport>;
  public pitchExportInvestmentsCreate(
    requestParameters?: PitchExportInvestmentsCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InvestmentsExport>>;
  public pitchExportInvestmentsCreate(
    requestParameters?: PitchExportInvestmentsCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InvestmentsExport>>;
  public pitchExportInvestmentsCreate(
    requestParameters?: PitchExportInvestmentsCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchExportInvestmentsCreate.');
    }
    const InvestmentsExportRequest = requestParameters?.InvestmentsExportRequest;
    if (InvestmentsExportRequest === null || InvestmentsExportRequest === undefined) {
      throw new Error('Required parameter InvestmentsExportRequest was null or undefined when calling pitchExportInvestmentsCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/export-investments`;
    return this.httpClient.request<InvestmentsExport>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: InvestmentsExportRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Export information about investments made on the pitch in a json format so it can be easily imported. Pass organization_number to add shares to that company. To update provide id or try by searching with allocation date and share_price.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchExportInvestmentsPartialUpdate(
    requestParameters?: PitchExportInvestmentsPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InvestmentsExport>;
  public pitchExportInvestmentsPartialUpdate(
    requestParameters?: PitchExportInvestmentsPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InvestmentsExport>>;
  public pitchExportInvestmentsPartialUpdate(
    requestParameters?: PitchExportInvestmentsPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InvestmentsExport>>;
  public pitchExportInvestmentsPartialUpdate(
    requestParameters?: PitchExportInvestmentsPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchExportInvestmentsPartialUpdate.');
    }
    const PatchedInvestmentsExportRequest = requestParameters?.PatchedInvestmentsExportRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/export-investments`;
    return this.httpClient.request<InvestmentsExport>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedInvestmentsExportRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Export information about investments made on the pitch in a json format so it can be easily imported. Pass organization_number to add shares to that company. To update provide id or try by searching with allocation date and share_price.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchExportInvestmentsUpdate(
    requestParameters?: PitchExportInvestmentsUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InvestmentsExport>;
  public pitchExportInvestmentsUpdate(
    requestParameters?: PitchExportInvestmentsUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InvestmentsExport>>;
  public pitchExportInvestmentsUpdate(
    requestParameters?: PitchExportInvestmentsUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InvestmentsExport>>;
  public pitchExportInvestmentsUpdate(
    requestParameters?: PitchExportInvestmentsUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchExportInvestmentsUpdate.');
    }
    const InvestmentsExportRequest = requestParameters?.InvestmentsExportRequest;
    if (InvestmentsExportRequest === null || InvestmentsExportRequest === undefined) {
      throw new Error('Required parameter InvestmentsExportRequest was null or undefined when calling pitchExportInvestmentsUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/export-investments`;
    return this.httpClient.request<InvestmentsExport>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: InvestmentsExportRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Toggle &#x60;featured&#x60; value on Pitch.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchFeaturedPartialUpdate(
    requestParameters?: PitchFeaturedPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchFeaturedPartialUpdate(
    requestParameters?: PitchFeaturedPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchFeaturedPartialUpdate(
    requestParameters?: PitchFeaturedPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchFeaturedPartialUpdate(
    requestParameters?: PitchFeaturedPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchFeaturedPartialUpdate.');
    }
    const PatchedDeckPitchDetailRequest = requestParameters?.PatchedDeckPitchDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/featured`;
    return this.httpClient.request<DeckPitchDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Toggle &#x60;featured&#x60; value on Pitch.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchFeaturedUpdate(
    requestParameters?: PitchFeaturedUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchFeaturedUpdate(
    requestParameters?: PitchFeaturedUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchFeaturedUpdate(
    requestParameters?: PitchFeaturedUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchFeaturedUpdate(
    requestParameters?: PitchFeaturedUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchFeaturedUpdate.');
    }
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchFeaturedUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/featured`;
    return this.httpClient.request<DeckPitchDetail>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchHistoryRetrieve(
    requestParameters?: PitchHistoryRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckLogEntry>;
  public pitchHistoryRetrieve(
    requestParameters?: PitchHistoryRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckLogEntry>>;
  public pitchHistoryRetrieve(
    requestParameters?: PitchHistoryRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckLogEntry>>;
  public pitchHistoryRetrieve(
    requestParameters?: PitchHistoryRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchHistoryRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/history`;
    return this.httpClient.request<DeckLogEntry>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchInvitationsRetrieve(
    requestParameters?: PitchInvitationsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchInvitationsRetrieve(
    requestParameters?: PitchInvitationsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchInvitationsRetrieve(
    requestParameters?: PitchInvitationsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchInvitationsRetrieve(
    requestParameters?: PitchInvitationsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchInvitationsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/invitations`;
    return this.httpClient.request<DeckPitchDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Create PitchInvitation and send email with link to pitch. If user doesn\&#39;t exists then add registration link.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchInviteCreate(
    requestParameters?: PitchInviteCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchInviteCreate(
    requestParameters?: PitchInviteCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchInviteCreate(
    requestParameters?: PitchInviteCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchInviteCreate(
    requestParameters?: PitchInviteCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchInviteCreate.');
    }
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchInviteCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/invite`;
    return this.httpClient.request<DeckPitchDetail>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchList(
    requestParameters?: PitchListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckPitchList>;
  public pitchList(
    requestParameters?: PitchListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckPitchList>>;
  public pitchList(
    requestParameters?: PitchListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckPitchList>>;
  public pitchList(
    requestParameters?: PitchListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const company_id = requestParameters?.company_id;
    const company_name = requestParameters?.company_name;
    const labels = requestParameters?.labels;
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const visibility = requestParameters?.visibility;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (company_name !== undefined && company_name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_name, 'company_name');
    }
    if (labels) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, [...labels].join(COLLECTION_FORMATS['csv']), 'labels');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (visibility) {
      visibility.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'visibility');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch`;
    return this.httpClient.request<PaginatedDeckPitchList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchPartialUpdate(
    requestParameters?: PitchPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchPartialUpdate(
    requestParameters?: PitchPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchPartialUpdate(
    requestParameters?: PitchPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchPartialUpdate(
    requestParameters?: PitchPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchPartialUpdate.');
    }
    const PatchedDeckPitchDetailRequest = requestParameters?.PatchedDeckPitchDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchRetrieve(
    requestParameters?: PitchRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchRetrieve(
    requestParameters?: PitchRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchRetrieve(
    requestParameters?: PitchRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchRetrieve(
    requestParameters?: PitchRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchSendEmailsCreate(
    requestParameters?: PitchSendEmailsCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchSendEmailsCreate(
    requestParameters?: PitchSendEmailsCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchSendEmailsCreate(
    requestParameters?: PitchSendEmailsCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchSendEmailsCreate(
    requestParameters?: PitchSendEmailsCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchSendEmailsCreate.');
    }
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchSendEmailsCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/send-emails`;
    return this.httpClient.request<DeckPitchDetail>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Pitch model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchUpdate(
    requestParameters?: PitchUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchDetail>;
  public pitchUpdate(
    requestParameters?: PitchUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchDetail>>;
  public pitchUpdate(
    requestParameters?: PitchUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchDetail>>;
  public pitchUpdate(
    requestParameters?: PitchUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchUpdate.');
    }
    const DeckPitchDetailRequest = requestParameters?.DeckPitchDetailRequest;
    if (DeckPitchDetailRequest === null || DeckPitchDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchDetailRequest was null or undefined when calling pitchUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitch/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchDetail>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switches the state of the flag &#x60;muted&#x60; on multiple objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesAnalysesBatchMutedPartialUpdate(
    requestParameters?: PitchesAnalysesBatchMutedPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckAnalysis>;
  public pitchesAnalysesBatchMutedPartialUpdate(
    requestParameters?: PitchesAnalysesBatchMutedPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckAnalysis>>;
  public pitchesAnalysesBatchMutedPartialUpdate(
    requestParameters?: PitchesAnalysesBatchMutedPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckAnalysis>>;
  public pitchesAnalysesBatchMutedPartialUpdate(
    requestParameters?: PitchesAnalysesBatchMutedPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckAnalysisRequest = requestParameters?.PatchedDeckAnalysisRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/analyses/batch-muted`;
    return this.httpClient.request<DeckAnalysis>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckAnalysisRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Analysis models.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesAnalysesList(
    requestParameters?: PitchesAnalysesListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckAnalysisList>;
  public pitchesAnalysesList(
    requestParameters?: PitchesAnalysesListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckAnalysisList>>;
  public pitchesAnalysesList(
    requestParameters?: PitchesAnalysesListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckAnalysisList>>;
  public pitchesAnalysesList(
    requestParameters?: PitchesAnalysesListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const filter = requestParameters?.filter;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const pitch_id = requestParameters?.pitch_id;
    const user_id = requestParameters?.user_id;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (filter !== undefined && filter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (pitch_id !== undefined && pitch_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch_id, 'pitch_id');
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/analyses`;
    return this.httpClient.request<PaginatedDeckAnalysisList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switches the state of the flag &#x60;muted&#x60; on Analysis object.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesAnalysesMutePartialUpdate(
    requestParameters?: PitchesAnalysesMutePartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckAnalysis>;
  public pitchesAnalysesMutePartialUpdate(
    requestParameters?: PitchesAnalysesMutePartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckAnalysis>>;
  public pitchesAnalysesMutePartialUpdate(
    requestParameters?: PitchesAnalysesMutePartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckAnalysis>>;
  public pitchesAnalysesMutePartialUpdate(
    requestParameters?: PitchesAnalysesMutePartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesAnalysesMutePartialUpdate.');
    }
    const PatchedDeckAnalysisRequest = requestParameters?.PatchedDeckAnalysisRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/analyses/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/mute`;
    return this.httpClient.request<DeckAnalysis>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckAnalysisRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switches the state of the flag &#x60;muted&#x60; on Analysis object.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesAnalysesMuteUpdate(
    requestParameters?: PitchesAnalysesMuteUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckAnalysis>;
  public pitchesAnalysesMuteUpdate(
    requestParameters?: PitchesAnalysesMuteUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckAnalysis>>;
  public pitchesAnalysesMuteUpdate(
    requestParameters?: PitchesAnalysesMuteUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckAnalysis>>;
  public pitchesAnalysesMuteUpdate(
    requestParameters?: PitchesAnalysesMuteUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesAnalysesMuteUpdate.');
    }
    const DeckAnalysisRequest = requestParameters?.DeckAnalysisRequest;
    if (DeckAnalysisRequest === null || DeckAnalysisRequest === undefined) {
      throw new Error('Required parameter DeckAnalysisRequest was null or undefined when calling pitchesAnalysesMuteUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/analyses/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/mute`;
    return this.httpClient.request<DeckAnalysis>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckAnalysisRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Analysis models.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesAnalysesRetrieve(
    requestParameters?: PitchesAnalysesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckAnalysis>;
  public pitchesAnalysesRetrieve(
    requestParameters?: PitchesAnalysesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckAnalysis>>;
  public pitchesAnalysesRetrieve(
    requestParameters?: PitchesAnalysesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckAnalysis>>;
  public pitchesAnalysesRetrieve(
    requestParameters?: PitchesAnalysesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesAnalysesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/analyses/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckAnalysis>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesCreate(
    requestParameters?: PitchesSelfPublishFileTypesCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishFileType>;
  public pitchesSelfPublishFileTypesCreate(
    requestParameters?: PitchesSelfPublishFileTypesCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesCreate(
    requestParameters?: PitchesSelfPublishFileTypesCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesCreate(
    requestParameters?: PitchesSelfPublishFileTypesCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckPitchSelfPublishFileTypeRequest = requestParameters?.DeckPitchSelfPublishFileTypeRequest;
    if (DeckPitchSelfPublishFileTypeRequest === null || DeckPitchSelfPublishFileTypeRequest === undefined) {
      throw new Error(
        'Required parameter DeckPitchSelfPublishFileTypeRequest was null or undefined when calling pitchesSelfPublishFileTypesCreate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types`;
    return this.httpClient.request<DeckPitchSelfPublishFileType>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchSelfPublishFileTypeRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesDestroy(
    requestParameters?: PitchesSelfPublishFileTypesDestroyRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any>;
  public pitchesSelfPublishFileTypesDestroy(
    requestParameters?: PitchesSelfPublishFileTypesDestroyRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public pitchesSelfPublishFileTypesDestroy(
    requestParameters?: PitchesSelfPublishFileTypesDestroyRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public pitchesSelfPublishFileTypesDestroy(
    requestParameters?: PitchesSelfPublishFileTypesDestroyRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFileTypesDestroy.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesList(
    requestParameters?: PitchesSelfPublishFileTypesListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckPitchSelfPublishFileTypeListList>;
  public pitchesSelfPublishFileTypesList(
    requestParameters?: PitchesSelfPublishFileTypesListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckPitchSelfPublishFileTypeListList>>;
  public pitchesSelfPublishFileTypesList(
    requestParameters?: PitchesSelfPublishFileTypesListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckPitchSelfPublishFileTypeListList>>;
  public pitchesSelfPublishFileTypesList(
    requestParameters?: PitchesSelfPublishFileTypesListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types`;
    return this.httpClient.request<PaginatedDeckPitchSelfPublishFileTypeListList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesPartialUpdate(
    requestParameters?: PitchesSelfPublishFileTypesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishFileType>;
  public pitchesSelfPublishFileTypesPartialUpdate(
    requestParameters?: PitchesSelfPublishFileTypesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesPartialUpdate(
    requestParameters?: PitchesSelfPublishFileTypesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesPartialUpdate(
    requestParameters?: PitchesSelfPublishFileTypesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFileTypesPartialUpdate.');
    }
    const PatchedDeckPitchSelfPublishFileTypeRequest = requestParameters?.PatchedDeckPitchSelfPublishFileTypeRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishFileType>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchSelfPublishFileTypeRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesRetrieve(
    requestParameters?: PitchesSelfPublishFileTypesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishFileTypeList>;
  public pitchesSelfPublishFileTypesRetrieve(
    requestParameters?: PitchesSelfPublishFileTypesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishFileTypeList>>;
  public pitchesSelfPublishFileTypesRetrieve(
    requestParameters?: PitchesSelfPublishFileTypesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishFileTypeList>>;
  public pitchesSelfPublishFileTypesRetrieve(
    requestParameters?: PitchesSelfPublishFileTypesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFileTypesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishFileTypeList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFileTypesUpdate(
    requestParameters?: PitchesSelfPublishFileTypesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishFileType>;
  public pitchesSelfPublishFileTypesUpdate(
    requestParameters?: PitchesSelfPublishFileTypesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesUpdate(
    requestParameters?: PitchesSelfPublishFileTypesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishFileType>>;
  public pitchesSelfPublishFileTypesUpdate(
    requestParameters?: PitchesSelfPublishFileTypesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFileTypesUpdate.');
    }
    const DeckPitchSelfPublishFileTypeRequest = requestParameters?.DeckPitchSelfPublishFileTypeRequest;
    if (DeckPitchSelfPublishFileTypeRequest === null || DeckPitchSelfPublishFileTypeRequest === undefined) {
      throw new Error(
        'Required parameter DeckPitchSelfPublishFileTypeRequest was null or undefined when calling pitchesSelfPublishFileTypesUpdate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/file-types/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishFileType>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchSelfPublishFileTypeRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFilesPartialUpdate(
    requestParameters?: PitchesSelfPublishFilesPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckStatusChangeSelfPublishFile>;
  public pitchesSelfPublishFilesPartialUpdate(
    requestParameters?: PitchesSelfPublishFilesPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesPartialUpdate(
    requestParameters?: PitchesSelfPublishFilesPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesPartialUpdate(
    requestParameters?: PitchesSelfPublishFilesPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFilesPartialUpdate.');
    }
    const PatchedDeckStatusChangeSelfPublishFileRequest = requestParameters?.PatchedDeckStatusChangeSelfPublishFileRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckStatusChangeSelfPublishFile>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckStatusChangeSelfPublishFileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFilesRejectionReasonsRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<FileRejectionReason>;
  public pitchesSelfPublishFilesRejectionReasonsRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<FileRejectionReason>>;
  public pitchesSelfPublishFilesRejectionReasonsRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<FileRejectionReason>>;
  public pitchesSelfPublishFilesRejectionReasonsRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/files/rejection_reasons`;
    return this.httpClient.request<FileRejectionReason>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFilesRetrieve(
    requestParameters?: PitchesSelfPublishFilesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckStatusChangeSelfPublishFile>;
  public pitchesSelfPublishFilesRetrieve(
    requestParameters?: PitchesSelfPublishFilesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesRetrieve(
    requestParameters?: PitchesSelfPublishFilesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesRetrieve(
    requestParameters?: PitchesSelfPublishFilesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFilesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckStatusChangeSelfPublishFile>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishFilesUpdate(
    requestParameters?: PitchesSelfPublishFilesUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckStatusChangeSelfPublishFile>;
  public pitchesSelfPublishFilesUpdate(
    requestParameters?: PitchesSelfPublishFilesUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesUpdate(
    requestParameters?: PitchesSelfPublishFilesUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckStatusChangeSelfPublishFile>>;
  public pitchesSelfPublishFilesUpdate(
    requestParameters?: PitchesSelfPublishFilesUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishFilesUpdate.');
    }
    const DeckStatusChangeSelfPublishFileRequest = requestParameters?.DeckStatusChangeSelfPublishFileRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/files/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckStatusChangeSelfPublishFile>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckStatusChangeSelfPublishFileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for PitchSelfPublish model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishList(
    requestParameters?: PitchesSelfPublishListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckPitchSelfPublishDetailList>;
  public pitchesSelfPublishList(
    requestParameters?: PitchesSelfPublishListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckPitchSelfPublishDetailList>>;
  public pitchesSelfPublishList(
    requestParameters?: PitchesSelfPublishListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckPitchSelfPublishDetailList>>;
  public pitchesSelfPublishList(
    requestParameters?: PitchesSelfPublishListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const created_from = requestParameters?.created_from;
    const created_to = requestParameters?.created_to;
    const filter = requestParameters?.filter;
    const limit = requestParameters?.limit;
    const modified_from = requestParameters?.modified_from;
    const modified_to = requestParameters?.modified_to;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const status = requestParameters?.status;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (created_from !== undefined && created_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_from, 'created_from');
    }
    if (created_to !== undefined && created_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_to, 'created_to');
    }
    if (filter !== undefined && filter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (modified_from !== undefined && modified_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_from, 'modified_from');
    }
    if (modified_to !== undefined && modified_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_to, 'modified_to');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish`;
    return this.httpClient.request<PaginatedDeckPitchSelfPublishDetailList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for PitchSelfPublish model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishPartialUpdate(
    requestParameters?: PitchesSelfPublishPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishDetail>;
  public pitchesSelfPublishPartialUpdate(
    requestParameters?: PitchesSelfPublishPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishPartialUpdate(
    requestParameters?: PitchesSelfPublishPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishPartialUpdate(
    requestParameters?: PitchesSelfPublishPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishPartialUpdate.');
    }
    const PatchedDeckPitchSelfPublishDetailRequest = requestParameters?.PatchedDeckPitchSelfPublishDetailRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishDetail>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchSelfPublishDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for PitchSelfPublish model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishRetrieve(
    requestParameters?: PitchesSelfPublishRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishDetail>;
  public pitchesSelfPublishRetrieve(
    requestParameters?: PitchesSelfPublishRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishRetrieve(
    requestParameters?: PitchesSelfPublishRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishRetrieve(
    requestParameters?: PitchesSelfPublishRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsCreate(
    requestParameters?: PitchesSelfPublishTagsCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckSelfPublishTag>;
  public pitchesSelfPublishTagsCreate(
    requestParameters?: PitchesSelfPublishTagsCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsCreate(
    requestParameters?: PitchesSelfPublishTagsCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsCreate(
    requestParameters?: PitchesSelfPublishTagsCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckSelfPublishTagRequest = requestParameters?.DeckSelfPublishTagRequest;
    if (DeckSelfPublishTagRequest === null || DeckSelfPublishTagRequest === undefined) {
      throw new Error('Required parameter DeckSelfPublishTagRequest was null or undefined when calling pitchesSelfPublishTagsCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags`;
    return this.httpClient.request<DeckSelfPublishTag>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckSelfPublishTagRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsDestroy(
    requestParameters?: PitchesSelfPublishTagsDestroyRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any>;
  public pitchesSelfPublishTagsDestroy(
    requestParameters?: PitchesSelfPublishTagsDestroyRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public pitchesSelfPublishTagsDestroy(
    requestParameters?: PitchesSelfPublishTagsDestroyRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public pitchesSelfPublishTagsDestroy(
    requestParameters?: PitchesSelfPublishTagsDestroyRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishTagsDestroy.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsList(
    requestParameters?: PitchesSelfPublishTagsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckSelfPublishTagList>;
  public pitchesSelfPublishTagsList(
    requestParameters?: PitchesSelfPublishTagsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckSelfPublishTagList>>;
  public pitchesSelfPublishTagsList(
    requestParameters?: PitchesSelfPublishTagsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckSelfPublishTagList>>;
  public pitchesSelfPublishTagsList(
    requestParameters?: PitchesSelfPublishTagsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags`;
    return this.httpClient.request<PaginatedDeckSelfPublishTagList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsPartialUpdate(
    requestParameters?: PitchesSelfPublishTagsPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckSelfPublishTag>;
  public pitchesSelfPublishTagsPartialUpdate(
    requestParameters?: PitchesSelfPublishTagsPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsPartialUpdate(
    requestParameters?: PitchesSelfPublishTagsPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsPartialUpdate(
    requestParameters?: PitchesSelfPublishTagsPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishTagsPartialUpdate.');
    }
    const PatchedDeckSelfPublishTagRequest = requestParameters?.PatchedDeckSelfPublishTagRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckSelfPublishTag>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckSelfPublishTagRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsRetrieve(
    requestParameters?: PitchesSelfPublishTagsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckSelfPublishTag>;
  public pitchesSelfPublishTagsRetrieve(
    requestParameters?: PitchesSelfPublishTagsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsRetrieve(
    requestParameters?: PitchesSelfPublishTagsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsRetrieve(
    requestParameters?: PitchesSelfPublishTagsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishTagsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckSelfPublishTag>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishTagsUpdate(
    requestParameters?: PitchesSelfPublishTagsUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckSelfPublishTag>;
  public pitchesSelfPublishTagsUpdate(
    requestParameters?: PitchesSelfPublishTagsUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsUpdate(
    requestParameters?: PitchesSelfPublishTagsUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckSelfPublishTag>>;
  public pitchesSelfPublishTagsUpdate(
    requestParameters?: PitchesSelfPublishTagsUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishTagsUpdate.');
    }
    const DeckSelfPublishTagRequest = requestParameters?.DeckSelfPublishTagRequest;
    if (DeckSelfPublishTagRequest === null || DeckSelfPublishTagRequest === undefined) {
      throw new Error('Required parameter DeckSelfPublishTagRequest was null or undefined when calling pitchesSelfPublishTagsUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/tags/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckSelfPublishTag>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckSelfPublishTagRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for PitchSelfPublish model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSelfPublishUpdate(
    requestParameters?: PitchesSelfPublishUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchSelfPublishDetail>;
  public pitchesSelfPublishUpdate(
    requestParameters?: PitchesSelfPublishUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishUpdate(
    requestParameters?: PitchesSelfPublishUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchSelfPublishDetail>>;
  public pitchesSelfPublishUpdate(
    requestParameters?: PitchesSelfPublishUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSelfPublishUpdate.');
    }
    const DeckPitchSelfPublishDetailRequest = requestParameters?.DeckPitchSelfPublishDetailRequest;
    if (DeckPitchSelfPublishDetailRequest === null || DeckPitchSelfPublishDetailRequest === undefined) {
      throw new Error('Required parameter DeckPitchSelfPublishDetailRequest was null or undefined when calling pitchesSelfPublishUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchSelfPublishDetail>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchSelfPublishDetailRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSubscriptionsList(
    requestParameters?: PitchesSubscriptionsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckPitchesSubscriptionList>;
  public pitchesSubscriptionsList(
    requestParameters?: PitchesSubscriptionsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckPitchesSubscriptionList>>;
  public pitchesSubscriptionsList(
    requestParameters?: PitchesSubscriptionsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckPitchesSubscriptionList>>;
  public pitchesSubscriptionsList(
    requestParameters?: PitchesSubscriptionsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const added_from = requestParameters?.added_from;
    const added_to = requestParameters?.added_to;
    const company_id = requestParameters?.company_id;
    const filter = requestParameters?.filter;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const pitch = requestParameters?.pitch;
    const pitch_name = requestParameters?.pitch_name;
    const subscribed = requestParameters?.subscribed;
    const user_id = requestParameters?.user_id;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (added_from !== undefined && added_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_from, 'added_from');
    }
    if (added_to !== undefined && added_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_to, 'added_to');
    }
    if (company_id !== undefined && company_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>company_id, 'company_id');
    }
    if (filter !== undefined && filter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (pitch !== undefined && pitch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch, 'pitch');
    }
    if (pitch_name !== undefined && pitch_name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch_name, 'pitch_name');
    }
    if (subscribed !== undefined && subscribed !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subscribed, 'subscribed');
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/subscriptions`;
    return this.httpClient.request<PaginatedDeckPitchesSubscriptionList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSubscriptionsRetrieve(
    requestParameters?: PitchesSubscriptionsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchesSubscription>;
  public pitchesSubscriptionsRetrieve(
    requestParameters?: PitchesSubscriptionsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchesSubscription>>;
  public pitchesSubscriptionsRetrieve(
    requestParameters?: PitchesSubscriptionsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchesSubscription>>;
  public pitchesSubscriptionsRetrieve(
    requestParameters?: PitchesSubscriptionsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSubscriptionsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/subscriptions/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckPitchesSubscription>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSubscriptionsUnsubscribePartialUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribePartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchesSubscription>;
  public pitchesSubscriptionsUnsubscribePartialUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribePartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchesSubscription>>;
  public pitchesSubscriptionsUnsubscribePartialUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribePartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchesSubscription>>;
  public pitchesSubscriptionsUnsubscribePartialUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribePartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSubscriptionsUnsubscribePartialUpdate.');
    }
    const PatchedDeckPitchesSubscriptionRequest = requestParameters?.PatchedDeckPitchesSubscriptionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/subscriptions/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/unsubscribe`;
    return this.httpClient.request<DeckPitchesSubscription>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckPitchesSubscriptionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pitchesSubscriptionsUnsubscribeUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribeUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckPitchesSubscription>;
  public pitchesSubscriptionsUnsubscribeUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribeUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckPitchesSubscription>>;
  public pitchesSubscriptionsUnsubscribeUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribeUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckPitchesSubscription>>;
  public pitchesSubscriptionsUnsubscribeUpdate(
    requestParameters?: PitchesSubscriptionsUnsubscribeUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling pitchesSubscriptionsUnsubscribeUpdate.');
    }
    const DeckPitchesSubscriptionRequest = requestParameters?.DeckPitchesSubscriptionRequest;
    if (DeckPitchesSubscriptionRequest === null || DeckPitchesSubscriptionRequest === undefined) {
      throw new Error(
        'Required parameter DeckPitchesSubscriptionRequest was null or undefined when calling pitchesSubscriptionsUnsubscribeUpdate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/subscriptions/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/unsubscribe`;
    return this.httpClient.request<DeckPitchesSubscription>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckPitchesSubscriptionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Adds answer to chosen question or updates the answer.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionAnswerCreate(
    requestParameters?: QuestionAnswerCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Answer>;
  public questionAnswerCreate(
    requestParameters?: QuestionAnswerCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Answer>>;
  public questionAnswerCreate(
    requestParameters?: QuestionAnswerCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Answer>>;
  public questionAnswerCreate(
    requestParameters?: QuestionAnswerCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionAnswerCreate.');
    }
    const DeckAnswerUpdateRequest = requestParameters?.DeckAnswerUpdateRequest;
    if (DeckAnswerUpdateRequest === null || DeckAnswerUpdateRequest === undefined) {
      throw new Error('Required parameter DeckAnswerUpdateRequest was null or undefined when calling questionAnswerCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/answer`;
    return this.httpClient.request<Answer>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckAnswerUpdateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Adds answer to chosen question or updates the answer.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionAnswerPartialUpdate(
    requestParameters?: QuestionAnswerPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Answer>;
  public questionAnswerPartialUpdate(
    requestParameters?: QuestionAnswerPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Answer>>;
  public questionAnswerPartialUpdate(
    requestParameters?: QuestionAnswerPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Answer>>;
  public questionAnswerPartialUpdate(
    requestParameters?: QuestionAnswerPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionAnswerPartialUpdate.');
    }
    const PatchedDeckAnswerUpdateRequest = requestParameters?.PatchedDeckAnswerUpdateRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/answer`;
    return this.httpClient.request<Answer>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckAnswerUpdateRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switches the state of the flag &#x60;muted&#x60; on multiple objects.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionBatchMutedPartialUpdate(
    requestParameters?: QuestionBatchMutedPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckQuestion>;
  public questionBatchMutedPartialUpdate(
    requestParameters?: QuestionBatchMutedPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckQuestion>>;
  public questionBatchMutedPartialUpdate(
    requestParameters?: QuestionBatchMutedPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckQuestion>>;
  public questionBatchMutedPartialUpdate(
    requestParameters?: QuestionBatchMutedPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedDeckQuestionRequest = requestParameters?.PatchedDeckQuestionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/batch-muted`;
    return this.httpClient.request<DeckQuestion>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckQuestionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionList(
    requestParameters?: QuestionListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckQuestionList>;
  public questionList(
    requestParameters?: QuestionListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckQuestionList>>;
  public questionList(
    requestParameters?: QuestionListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckQuestionList>>;
  public questionList(
    requestParameters?: QuestionListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const filter = requestParameters?.filter;
    const limit = requestParameters?.limit;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const pitch_id = requestParameters?.pitch_id;
    const user_id = requestParameters?.user_id;
    const username = requestParameters?.username;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (filter !== undefined && filter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (pitch_id !== undefined && pitch_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pitch_id, 'pitch_id');
    }
    if (user_id !== undefined && user_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>user_id, 'user_id');
    }
    if (username !== undefined && username !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>username, 'username');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question`;
    return this.httpClient.request<PaginatedDeckQuestionList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switch the value of field &#x60;muted&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionMutePartialUpdate(
    requestParameters?: QuestionMutePartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckQuestion>;
  public questionMutePartialUpdate(
    requestParameters?: QuestionMutePartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckQuestion>>;
  public questionMutePartialUpdate(
    requestParameters?: QuestionMutePartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckQuestion>>;
  public questionMutePartialUpdate(
    requestParameters?: QuestionMutePartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionMutePartialUpdate.');
    }
    const PatchedDeckQuestionRequest = requestParameters?.PatchedDeckQuestionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/mute`;
    return this.httpClient.request<DeckQuestion>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckQuestionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Switch the value of field &#x60;muted&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionMuteUpdate(
    requestParameters?: QuestionMuteUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckQuestion>;
  public questionMuteUpdate(
    requestParameters?: QuestionMuteUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckQuestion>>;
  public questionMuteUpdate(
    requestParameters?: QuestionMuteUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckQuestion>>;
  public questionMuteUpdate(
    requestParameters?: QuestionMuteUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionMuteUpdate.');
    }
    const DeckQuestionRequest = requestParameters?.DeckQuestionRequest;
    if (DeckQuestionRequest === null || DeckQuestionRequest === undefined) {
      throw new Error('Required parameter DeckQuestionRequest was null or undefined when calling questionMuteUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/mute`;
    return this.httpClient.request<DeckQuestion>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckQuestionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionRetrieve(
    requestParameters?: QuestionRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckQuestion>;
  public questionRetrieve(
    requestParameters?: QuestionRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckQuestion>>;
  public questionRetrieve(
    requestParameters?: QuestionRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckQuestion>>;
  public questionRetrieve(
    requestParameters?: QuestionRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/question/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckQuestion>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * View for generating AWS link to questionnaire answers
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionnaireAnswersRetrieve(
    requestParameters?: QuestionnaireAnswersRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public questionnaireAnswersRetrieve(
    requestParameters?: QuestionnaireAnswersRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public questionnaireAnswersRetrieve(
    requestParameters?: QuestionnaireAnswersRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public questionnaireAnswersRetrieve(
    requestParameters?: QuestionnaireAnswersRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const object_id = requestParameters?.object_id;
    if (object_id === null || object_id === undefined) {
      throw new Error('Required parameter object_id was null or undefined when calling questionnaireAnswersRetrieve.');
    }
    const slug = requestParameters?.slug;
    if (slug === null || slug === undefined) {
      throw new Error('Required parameter slug was null or undefined when calling questionnaireAnswersRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/questionnaire/${this.configuration.encodeParam({
      name: 'slug',
      value: slug,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/${this.configuration.encodeParam({
      name: 'object_id',
      value: object_id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for getting questions and answers from KYC for users and investment companies.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionnaireList(
    requestParameters?: QuestionnaireListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckKYCList>;
  public questionnaireList(
    requestParameters?: QuestionnaireListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckKYCList>>;
  public questionnaireList(
    requestParameters?: QuestionnaireListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckKYCList>>;
  public questionnaireList(
    requestParameters?: QuestionnaireListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    const limit = requestParameters?.limit;
    const model = requestParameters?.model;
    const offset = requestParameters?.offset;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (id !== undefined && id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>id, 'id');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (model !== undefined && model !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>model, 'model');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/questionnaire`;
    return this.httpClient.request<PaginatedDeckKYCList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for getting questions and answers from KYC for users and investment companies.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public questionnaireRetrieve(
    requestParameters?: QuestionnaireRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<QuestionnaireResponse>;
  public questionnaireRetrieve(
    requestParameters?: QuestionnaireRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<QuestionnaireResponse>>;
  public questionnaireRetrieve(
    requestParameters?: QuestionnaireRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<QuestionnaireResponse>>;
  public questionnaireRetrieve(
    requestParameters?: QuestionnaireRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling questionnaireRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/questionnaire/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<QuestionnaireResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersCreate(
    requestParameters?: SecondhandOffersCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckOffer>;
  public secondhandOffersCreate(
    requestParameters?: SecondhandOffersCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckOffer>>;
  public secondhandOffersCreate(
    requestParameters?: SecondhandOffersCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckOffer>>;
  public secondhandOffersCreate(
    requestParameters?: SecondhandOffersCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckOfferRequest = requestParameters?.DeckOfferRequest;
    if (DeckOfferRequest === null || DeckOfferRequest === undefined) {
      throw new Error('Required parameter DeckOfferRequest was null or undefined when calling secondhandOffersCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers`;
    return this.httpClient.request<DeckOffer>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckOfferRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersList(
    requestParameters?: SecondhandOffersListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckOfferList>;
  public secondhandOffersList(
    requestParameters?: SecondhandOffersListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckOfferList>>;
  public secondhandOffersList(
    requestParameters?: SecondhandOffersListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckOfferList>>;
  public secondhandOffersList(
    requestParameters?: SecondhandOffersListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const created_date_from = requestParameters?.created_date_from;
    const created_date_to = requestParameters?.created_date_to;
    const limit = requestParameters?.limit;
    const modified_date_from = requestParameters?.modified_date_from;
    const modified_date_to = requestParameters?.modified_date_to;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const shares_from = requestParameters?.shares_from;
    const shares_to = requestParameters?.shares_to;
    const status = requestParameters?.status;
    const subscribed = requestParameters?.subscribed;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (created_date_from !== undefined && created_date_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_date_from, 'created_date_from');
    }
    if (created_date_to !== undefined && created_date_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_date_to, 'created_date_to');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (modified_date_from !== undefined && modified_date_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_date_from, 'modified_date_from');
    }
    if (modified_date_to !== undefined && modified_date_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_date_to, 'modified_date_to');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (shares_from !== undefined && shares_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>shares_from, 'shares_from');
    }
    if (shares_to !== undefined && shares_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>shares_to, 'shares_to');
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'status');
      });
    }
    if (subscribed !== undefined && subscribed !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subscribed, 'subscribed');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers`;
    return this.httpClient.request<PaginatedDeckOfferList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersPartialUpdate(
    requestParameters?: SecondhandOffersPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckOffer>;
  public secondhandOffersPartialUpdate(
    requestParameters?: SecondhandOffersPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckOffer>>;
  public secondhandOffersPartialUpdate(
    requestParameters?: SecondhandOffersPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckOffer>>;
  public secondhandOffersPartialUpdate(
    requestParameters?: SecondhandOffersPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling secondhandOffersPartialUpdate.');
    }
    const PatchedDeckOfferRequest = requestParameters?.PatchedDeckOfferRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckOffer>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckOfferRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersRetrieve(
    requestParameters?: SecondhandOffersRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckOffer>;
  public secondhandOffersRetrieve(
    requestParameters?: SecondhandOffersRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckOffer>>;
  public secondhandOffersRetrieve(
    requestParameters?: SecondhandOffersRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckOffer>>;
  public secondhandOffersRetrieve(
    requestParameters?: SecondhandOffersRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling secondhandOffersRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckOffer>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersSubscriptionsRetrieve(
    requestParameters?: SecondhandOffersSubscriptionsRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckSecondhandSubscription>;
  public secondhandOffersSubscriptionsRetrieve(
    requestParameters?: SecondhandOffersSubscriptionsRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckSecondhandSubscription>>;
  public secondhandOffersSubscriptionsRetrieve(
    requestParameters?: SecondhandOffersSubscriptionsRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckSecondhandSubscription>>;
  public secondhandOffersSubscriptionsRetrieve(
    requestParameters?: SecondhandOffersSubscriptionsRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling secondhandOffersSubscriptionsRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/subscriptions`;
    return this.httpClient.request<DeckSecondhandSubscription>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Offer model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandOffersUpdate(
    requestParameters?: SecondhandOffersUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckOffer>;
  public secondhandOffersUpdate(
    requestParameters?: SecondhandOffersUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckOffer>>;
  public secondhandOffersUpdate(
    requestParameters?: SecondhandOffersUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckOffer>>;
  public secondhandOffersUpdate(
    requestParameters?: SecondhandOffersUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling secondhandOffersUpdate.');
    }
    const DeckOfferRequest = requestParameters?.DeckOfferRequest;
    if (DeckOfferRequest === null || DeckOfferRequest === undefined) {
      throw new Error('Required parameter DeckOfferRequest was null or undefined when calling secondhandOffersUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/offers/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckOffer>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckOfferRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for Subscription model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public secondhandSubscriptionsList(
    requestParameters?: SecondhandSubscriptionsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckSecondhandSubscriptionList>;
  public secondhandSubscriptionsList(
    requestParameters?: SecondhandSubscriptionsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckSecondhandSubscriptionList>>;
  public secondhandSubscriptionsList(
    requestParameters?: SecondhandSubscriptionsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckSecondhandSubscriptionList>>;
  public secondhandSubscriptionsList(
    requestParameters?: SecondhandSubscriptionsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const created_date_from = requestParameters?.created_date_from;
    const created_date_to = requestParameters?.created_date_to;
    const limit = requestParameters?.limit;
    const modified_date_from = requestParameters?.modified_date_from;
    const modified_date_to = requestParameters?.modified_date_to;
    const offer_id = requestParameters?.offer_id;
    const offset = requestParameters?.offset;
    const search = requestParameters?.search;
    const subscribed = requestParameters?.subscribed;
    const type = requestParameters?.type;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (created_date_from !== undefined && created_date_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_date_from, 'created_date_from');
    }
    if (created_date_to !== undefined && created_date_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>created_date_to, 'created_date_to');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (modified_date_from !== undefined && modified_date_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_date_from, 'modified_date_from');
    }
    if (modified_date_to !== undefined && modified_date_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>modified_date_to, 'modified_date_to');
    }
    if (offer_id !== undefined && offer_id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offer_id, 'offer_id');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (subscribed !== undefined && subscribed !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subscribed, 'subscribed');
    }
    if (type !== undefined && type !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, 'type');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/secondhand/subscriptions`;
    return this.httpClient.request<PaginatedDeckSecondhandSubscriptionList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Deck view for PitchSelfPublish model.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public selfPublishDetailFileTypesRetrieve(
    requestParameters?: SelfPublishDetailFileTypesRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<SelfPublishFileType>;
  public selfPublishDetailFileTypesRetrieve(
    requestParameters?: SelfPublishDetailFileTypesRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<SelfPublishFileType>>;
  public selfPublishDetailFileTypesRetrieve(
    requestParameters?: SelfPublishDetailFileTypesRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<SelfPublishFileType>>;
  public selfPublishDetailFileTypesRetrieve(
    requestParameters?: SelfPublishDetailFileTypesRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling selfPublishDetailFileTypesRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pitches/self-publish/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/file_types`;
    return this.httpClient.request<SelfPublishFileType>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public statsExportInvestmentsList(
    requestParameters?: StatsExportInvestmentsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any>;
  public statsExportInvestmentsList(
    requestParameters?: StatsExportInvestmentsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public statsExportInvestmentsList(
    requestParameters?: StatsExportInvestmentsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public statsExportInvestmentsList(
    requestParameters?: StatsExportInvestmentsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext }
  ): Observable<any> {
    const end_date = requestParameters?.end_date;
    if (end_date === null || end_date === undefined) {
      throw new Error('Required parameter end_date was null or undefined when calling statsExportInvestmentsList.');
    }
    const series = requestParameters?.series;
    if (series === null || series === undefined) {
      throw new Error('Required parameter series was null or undefined when calling statsExportInvestmentsList.');
    }
    const start_date = requestParameters?.start_date;
    if (start_date === null || start_date === undefined) {
      throw new Error('Required parameter start_date was null or undefined when calling statsExportInvestmentsList.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (end_date !== undefined && end_date !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>end_date, 'end_date');
    }
    if (series !== undefined && series !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>series, 'series');
    }
    if (start_date !== undefined && start_date !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>start_date, 'start_date');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stats/export_investments`;
    return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public statsInvestmentCompaniesRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InvestmentCompanyStatistics>;
  public statsInvestmentCompaniesRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InvestmentCompanyStatistics>>;
  public statsInvestmentCompaniesRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InvestmentCompanyStatistics>>;
  public statsInvestmentCompaniesRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stats/investment-companies`;
    return this.httpClient.request<InvestmentCompanyStatistics>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public statsInvestmentsRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InvestmentStatistics>;
  public statsInvestmentsRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InvestmentStatistics>>;
  public statsInvestmentsRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InvestmentStatistics>>;
  public statsInvestmentsRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stats/investments`;
    return this.httpClient.request<InvestmentStatistics>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public statsPitchesRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PitchStatistics>;
  public statsPitchesRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PitchStatistics>>;
  public statsPitchesRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PitchStatistics>>;
  public statsPitchesRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stats/pitches`;
    return this.httpClient.request<PitchStatistics>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public statsUsersRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<UserStatistics>;
  public statsUsersRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<UserStatistics>>;
  public statsUsersRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<UserStatistics>>;
  public statsUsersRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stats/users`;
    return this.httpClient.request<UserStatistics>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Perform user AML screening
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersAmlCheckCreate(
    requestParameters?: UsersAmlCheckCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUser>;
  public usersAmlCheckCreate(
    requestParameters?: UsersAmlCheckCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUser>>;
  public usersAmlCheckCreate(
    requestParameters?: UsersAmlCheckCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUser>>;
  public usersAmlCheckCreate(
    requestParameters?: UsersAmlCheckCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersAmlCheckCreate.');
    }
    const DeckUserRequest = requestParameters?.DeckUserRequest;
    if (DeckUserRequest === null || DeckUserRequest === undefined) {
      throw new Error('Required parameter DeckUserRequest was null or undefined when calling usersAmlCheckCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckUser>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckUserRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Perform user AML screening
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersAmlCheckPartialUpdate(
    requestParameters?: UsersAmlCheckPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUser>;
  public usersAmlCheckPartialUpdate(
    requestParameters?: UsersAmlCheckPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUser>>;
  public usersAmlCheckPartialUpdate(
    requestParameters?: UsersAmlCheckPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUser>>;
  public usersAmlCheckPartialUpdate(
    requestParameters?: UsersAmlCheckPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersAmlCheckPartialUpdate.');
    }
    const PatchedDeckUserRequest = requestParameters?.PatchedDeckUserRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/aml-check`;
    return this.httpClient.request<DeckUser>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckUserRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Sets a value of customer_status flag for the users whose id are provided.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersBatchCustomerStatusPartialUpdate(
    requestParameters?: UsersBatchCustomerStatusPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<DeckUser>>;
  public usersBatchCustomerStatusPartialUpdate(
    requestParameters?: UsersBatchCustomerStatusPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<DeckUser>>>;
  public usersBatchCustomerStatusPartialUpdate(
    requestParameters?: UsersBatchCustomerStatusPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<DeckUser>>>;
  public usersBatchCustomerStatusPartialUpdate(
    requestParameters?: UsersBatchCustomerStatusPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const PatchedBatchCustomerStatusRequest = requestParameters?.PatchedBatchCustomerStatusRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/batch-customer-status`;
    return this.httpClient.request<Array<DeckUser>>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedBatchCustomerStatusRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersCreate(
    requestParameters?: UsersCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckCreateUser>;
  public usersCreate(
    requestParameters?: UsersCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckCreateUser>>;
  public usersCreate(
    requestParameters?: UsersCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckCreateUser>>;
  public usersCreate(
    requestParameters?: UsersCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckCreateUserRequest = requestParameters?.DeckCreateUserRequest;
    if (DeckCreateUserRequest === null || DeckCreateUserRequest === undefined) {
      throw new Error('Required parameter DeckCreateUserRequest was null or undefined when calling usersCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users`;
    return this.httpClient.request<DeckCreateUser>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckCreateUserRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersCurrentProfileRetrieve(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUser>;
  public usersCurrentProfileRetrieve(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUser>>;
  public usersCurrentProfileRetrieve(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUser>>;
  public usersCurrentProfileRetrieve(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/profile`;
    return this.httpClient.request<DeckUser>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersDownloadPepReportRetrieve(
    requestParameters?: UsersDownloadPepReportRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Link>;
  public usersDownloadPepReportRetrieve(
    requestParameters?: UsersDownloadPepReportRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Link>>;
  public usersDownloadPepReportRetrieve(
    requestParameters?: UsersDownloadPepReportRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Link>>;
  public usersDownloadPepReportRetrieve(
    requestParameters?: UsersDownloadPepReportRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersDownloadPepReportRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/download-pep-report`;
    return this.httpClient.request<Link>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Try fill pnr in user profile if pnr field is empty in profile
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersIdfyPnrCreate(
    requestParameters?: UsersIdfyPnrCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUserPNR>;
  public usersIdfyPnrCreate(
    requestParameters?: UsersIdfyPnrCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUserPNR>>;
  public usersIdfyPnrCreate(
    requestParameters?: UsersIdfyPnrCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUserPNR>>;
  public usersIdfyPnrCreate(
    requestParameters?: UsersIdfyPnrCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersIdfyPnrCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/idfy-pnr`;
    return this.httpClient.request<DeckUserPNR>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersList(
    requestParameters?: UsersListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckUserList>;
  public usersList(
    requestParameters?: UsersListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckUserList>>;
  public usersList(
    requestParameters?: UsersListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckUserList>>;
  public usersList(
    requestParameters?: UsersListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const added_from = requestParameters?.added_from;
    const added_to = requestParameters?.added_to;
    const invested_amount_from = requestParameters?.invested_amount_from;
    const invested_amount_to = requestParameters?.invested_amount_to;
    const invested_vs_declared = requestParameters?.invested_vs_declared;
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const offset = requestParameters?.offset;
    const order_by = requestParameters?.order_by;
    const phone = requestParameters?.phone;
    const social_auth_provider = requestParameters?.social_auth_provider;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (added_from !== undefined && added_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_from, 'added_from');
    }
    if (added_to !== undefined && added_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>added_to, 'added_to');
    }
    if (invested_amount_from !== undefined && invested_amount_from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>invested_amount_from, 'invested_amount_from');
    }
    if (invested_amount_to !== undefined && invested_amount_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>invested_amount_to, 'invested_amount_to');
    }
    if (invested_vs_declared !== undefined && invested_vs_declared !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>invested_vs_declared, 'invested_vs_declared');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (order_by !== undefined && order_by !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>order_by, 'order_by');
    }
    if (phone !== undefined && phone !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>phone, 'phone');
    }
    if (social_auth_provider !== undefined && social_auth_provider !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>social_auth_provider, 'social_auth_provider');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users`;
    return this.httpClient.request<PaginatedDeckUserList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersPartialUpdate(
    requestParameters?: UsersPartialUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUserProfile>;
  public usersPartialUpdate(
    requestParameters?: UsersPartialUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUserProfile>>;
  public usersPartialUpdate(
    requestParameters?: UsersPartialUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUserProfile>>;
  public usersPartialUpdate(
    requestParameters?: UsersPartialUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersPartialUpdate.');
    }
    const PatchedDeckUserProfileRequest = requestParameters?.PatchedDeckUserProfileRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckUserProfile>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: PatchedDeckUserProfileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersProfileRetrieve(
    requestParameters?: UsersProfileRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUserProfile>;
  public usersProfileRetrieve(
    requestParameters?: UsersProfileRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUserProfile>>;
  public usersProfileRetrieve(
    requestParameters?: UsersProfileRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUserProfile>>;
  public usersProfileRetrieve(
    requestParameters?: UsersProfileRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersProfileRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}/profile`;
    return this.httpClient.request<DeckUserProfile>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Reset password. Provide email.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersResetPasswordCreate(
    requestParameters?: UsersResetPasswordCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUser>;
  public usersResetPasswordCreate(
    requestParameters?: UsersResetPasswordCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUser>>;
  public usersResetPasswordCreate(
    requestParameters?: UsersResetPasswordCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUser>>;
  public usersResetPasswordCreate(
    requestParameters?: UsersResetPasswordCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const DeckUserRequest = requestParameters?.DeckUserRequest;
    if (DeckUserRequest === null || DeckUserRequest === undefined) {
      throw new Error('Required parameter DeckUserRequest was null or undefined when calling usersResetPasswordCreate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/reset-password`;
    return this.httpClient.request<DeckUser>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckUserRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersRetrieve(
    requestParameters?: UsersRetrieveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUserDetail>;
  public usersRetrieve(
    requestParameters?: UsersRetrieveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUserDetail>>;
  public usersRetrieve(
    requestParameters?: UsersRetrieveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUserDetail>>;
  public usersRetrieve(
    requestParameters?: UsersRetrieveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersRetrieve.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckUserDetail>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Search users. Fields used: search: user\&#39;s first name, last name and email not_invited_to: pitch_id - excludes users invited to given pitch name: search only by name
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersSearchList(
    requestParameters?: UsersSearchListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PaginatedDeckSimpleUserList>;
  public usersSearchList(
    requestParameters?: UsersSearchListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PaginatedDeckSimpleUserList>>;
  public usersSearchList(
    requestParameters?: UsersSearchListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PaginatedDeckSimpleUserList>>;
  public usersSearchList(
    requestParameters?: UsersSearchListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const limit = requestParameters?.limit;
    const name = requestParameters?.name;
    const not_invited_to = requestParameters?.not_invited_to;
    const offset = requestParameters?.offset;
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'name');
    }
    if (not_invited_to !== undefined && not_invited_to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>not_invited_to, 'not_invited_to');
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>offset, 'offset');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/search`;
    return this.httpClient.request<PaginatedDeckSimpleUserList>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUpdate(
    requestParameters?: UsersUpdateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<DeckUserProfile>;
  public usersUpdate(
    requestParameters?: UsersUpdateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<DeckUserProfile>>;
  public usersUpdate(
    requestParameters?: UsersUpdateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<DeckUserProfile>>;
  public usersUpdate(
    requestParameters?: UsersUpdateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling usersUpdate.');
    }
    const DeckUserProfileRequest = requestParameters?.DeckUserProfileRequest;
    if (DeckUserProfileRequest === null || DeckUserProfileRequest === undefined) {
      throw new Error('Required parameter DeckUserProfileRequest was null or undefined when calling usersUpdate.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (SocialAuthentication) required
    localVarCredential = this.configuration.lookupCredential('SocialAuthentication');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (cookieAuth) required
    localVarCredential = this.configuration.lookupCredential('cookieAuth');
    if (localVarCredential) {
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/users/${this.configuration.encodeParam({
      name: 'id',
      value: id,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    return this.httpClient.request<DeckUserProfile>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: DeckUserProfileRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }
}
